interface EnumValueOption {
  /**
   * @description  The order position of each enum on the page
   */

  position?: number

  /**
   * @description  Count of enum
   */

  num?: number

  /**
   * @description  Whether to hide this enum on the page
   */

  hiddenSelect?: boolean

  /**
   * @description  The icon associated with the enum
   */

  icon?: string

  /**
   * @description  The backgroundColor associated with the enum
   */

  backgroundColor?: string

  /**
   * @description  The color associated with the enum
   */

  color?: string
}
export interface ModelEnumObjects {
  [key: string]: EnumValueOption
}
export const NotificationChannelEnumObjects: ModelEnumObjects = {
  App: {
    position: 0,
  },
  Sms: {
    position: 1,
  },
  Email: {
    position: 2,
  },
  Wechat: {
    position: 3,
  },
  Slack: {
    position: 4,
  },
  Feishu: {
    position: 5,
  },
  QiyeWechat: {
    position: 6,
  },
}
export const NotificationChannelEnums = [
  'App',
  'Sms',
  'Email',
  'Wechat',
  'Slack',
  'Feishu',
  'QiyeWechat',
]
export const enum NotificationChannelEnum {
  App = 'App',
  Sms = 'Sms',
  Email = 'Email',
  Wechat = 'Wechat',
  Slack = 'Slack',
  Feishu = 'Feishu',
  QiyeWechat = 'QiyeWechat',
}
export const NotificationTemplateEventNameEnumObjects: ModelEnumObjects = {
  Test: {
    position: 0,
  },
  SpaceExpiring: {
    position: 1,
  },
  ReservationStartHostReminder: {
    position: 2,
  },
  ReservationStartAttendeeReminder: {
    position: 3,
  },
  ReservationEndSoonReminder: {
    position: 4,
  },
  ReservationCreatedHostReminder: {
    position: 5,
  },
  ReservationCreatedAttendeeReminder: {
    position: 6,
  },
  SyncCalendarFailed: {
    position: 7,
  },
  ReservationRecurrentCreatedHostReminder: {
    position: 8,
  },
  ReservationRecurrentCreatedAttendeeReminder: {
    position: 9,
  },
  ReservationResourceOrTimeUpdated: {
    position: 10,
  },
  ReservationHostUpdatedOldHostReminder: {
    position: 11,
  },
  ReservationHostUpdatedNewHostReminder: {
    position: 12,
  },
  ReservationAttendeeUpdatedOldAttendeeReminder: {
    position: 13,
  },
  ReservationAttendeeUpdatedNewAttendeeReminder: {
    position: 14,
  },
  ReservationAdvanceTerminatedReminder: {
    position: 15,
  },
  ReservationServiceUpdated: {
    position: 16,
  },
  ReservationRecurrentApprovalReminder: {
    position: 17,
  },
  ReservationApprovalReminder: {
    position: 18,
  },
  ReservationApprovalPendingReminder: {
    position: 19,
  },
  ReservationApprovalCompleted: {
    position: 20,
  },
  ReservationCancelledHostReminder: {
    position: 21,
  },
  ReservationCancelledAttendeeReminder: {
    position: 22,
  },
  ReservationCancelledTaskReminder: {
    position: 23,
  },
  ReservationRecurrentCancelledHostReminder: {
    position: 24,
  },
  ReservationRecurrentCancelledAttendeeReminder: {
    position: 25,
  },
  ReservationCurrentRecurrentCancelledHostReminder: {
    position: 26,
  },
  ReservationCurrentRecurrentCancelledAttendeeReminder: {
    position: 27,
  },
  ReservationCheckinReminder: {
    position: 28,
  },
  ReservationNormalToRecurrent: {
    position: 29,
  },
  MeetingReservationReminder: {
    position: 30,
  },
  MeetingReservationTerminated: {
    position: 31,
  },
  MeetingReservationUpdated: {
    position: 32,
  },
  MeetingReservationCancelled: {
    position: 33,
  },
  MeetingReservationCancellation: {
    position: 34,
  },
  DeskReservationCreated: {
    position: 35,
  },
  DeskReservationReminder: {
    position: 36,
  },
  DeskReservationCancelled: {
    position: 37,
  },
  DeskReservationAutoTerminated: {
    position: 38,
  },
  SaasTransactionCreditSuccess: {
    position: 39,
  },
  SaasRenewSuccess: {
    position: 40,
  },
  SaasRenewFailed: {
    position: 41,
  },
  SaasSubscriptionExpired: {
    position: 42,
  },
  SaasSubscriptionPastDue: {
    position: 43,
  },
  SaasSubscriptionTrialExpiring: {
    position: 44,
  },
  VisitorRemindApprove: {
    position: 45,
  },
  VisitorSendInvite: {
    position: 46,
  },
  VisitorSignin: {
    position: 47,
  },
  VisitorSignout: {
    position: 48,
  },
  VisitorRemind: {
    position: 49,
  },
  VisitorLeaveRemind: {
    position: 50,
  },
  VisitorExternalAttendeesUpdated: {
    position: 51,
  },
  VisitorExternalAttendeesCancelled: {
    position: 52,
  },
  VisitorDisapprovedForHost: {
    position: 53,
  },
  VisitorApprovedForHost: {
    position: 54,
  },
  VisitorSigninForHost: {
    position: 55,
  },
  VisitorSigninForCreator: {
    position: 56,
  },
  VisitorSatisfactionSurvey: {
    position: 57,
  },
  VisitorNotSignout: {
    position: 58,
  },
  VisitorAcceptInvitation: {
    position: 59,
  },
  VisitorSignNDA: {
    position: 60,
  },
  VisitorApprovedForVisitor: {
    position: 61,
  },
  VisitorDisapprovedForVisitor: {
    position: 62,
  },
  VisitorWatchListRemind: {
    position: 63,
  },
  VisitorRequestSuccess: {
    position: 64,
  },
  VisitorCancelForHost: {
    position: 65,
  },
  VisitorCancelForVisitor: {
    position: 66,
  },
  TaskCreatedCreator: {
    position: 67,
  },
  TaskCreatedAssignTo: {
    position: 68,
  },
  TaskCompleted: {
    position: 69,
  },
  TaskExpired: {
    position: 70,
  },
  TaskUpdateInfo: {
    position: 71,
  },
  TaskRejected: {
    position: 72,
  },
  TaskCreatedRecurrentToCreator: {
    position: 73,
  },
  BlacklistViolation: {
    position: 74,
  },
  BlacklistViolationDepartment: {
    position: 75,
  },
  BlacklistViolationInvalid: {
    position: 76,
  },
  BlacklistByUserRule: {
    position: 77,
  },
  BlacklistByDepartmentRule: {
    position: 78,
  },
  BlacklistInvalid: {
    position: 79,
  },
  WaitlistCreated: {
    position: 80,
  },
  WaitlistPendingConfirm: {
    position: 81,
  },
  WaitlistConfirmed: {
    position: 82,
  },
  WaitlistTimeOutUnconfirmed: {
    position: 83,
  },
  WaitlistByOther: {
    position: 84,
  },
  WaitlistFailByRule: {
    position: 85,
  },
  WaitlistUpdate: {
    position: 86,
  },
  DeliveryCreated: {
    position: 87,
  },
  DeliveryExpiredToReceiver: {
    position: 88,
  },
  DeliveryExpiredToAssignTo: {
    position: 89,
  },
  DeliveryRejected: {
    position: 90,
  },
  DeliveryAssignedUpdate: {
    position: 91,
  },
  SpaceCreateApply: {
    position: 92,
  },
  SpaceCreated: {
    position: 93,
  },
  UserCreatedRemind: {
    position: 94,
  },
  TaskBeforeExpiredRemind: {
    position: 95,
  },
  DeliveryBeforeExpiredRemindToReceiver: {
    position: 96,
  },
  DeliveryBeforeExpiredRemindToAssignTo: {
    position: 97,
  },
  DeliveryAreaChangeRemind: {
    position: 98,
  },
  ApprovalRequestCreated: {
    position: 99,
  },
  AutoCheckin: {
    position: 100,
  },
  AutoCheckout: {
    position: 101,
  },
  AutoCheckinWithoutReservationReminder: {
    position: 102,
  },
  OutlookSubscriptionRenewFailed: {
    position: 103,
  },
  SpacePlanExpiredRemind: {
    position: 104,
  },
}
export const NotificationTemplateEventNameEnums = [
  'Test',
  'SpaceExpiring',
  'ReservationStartHostReminder',
  'ReservationStartAttendeeReminder',
  'ReservationEndSoonReminder',
  'ReservationCreatedHostReminder',
  'ReservationCreatedAttendeeReminder',
  'SyncCalendarFailed',
  'ReservationRecurrentCreatedHostReminder',
  'ReservationRecurrentCreatedAttendeeReminder',
  'ReservationResourceOrTimeUpdated',
  'ReservationHostUpdatedOldHostReminder',
  'ReservationHostUpdatedNewHostReminder',
  'ReservationAttendeeUpdatedOldAttendeeReminder',
  'ReservationAttendeeUpdatedNewAttendeeReminder',
  'ReservationAdvanceTerminatedReminder',
  'ReservationServiceUpdated',
  'ReservationRecurrentApprovalReminder',
  'ReservationApprovalReminder',
  'ReservationApprovalPendingReminder',
  'ReservationApprovalCompleted',
  'ReservationCancelledHostReminder',
  'ReservationCancelledAttendeeReminder',
  'ReservationCancelledTaskReminder',
  'ReservationRecurrentCancelledHostReminder',
  'ReservationRecurrentCancelledAttendeeReminder',
  'ReservationCurrentRecurrentCancelledHostReminder',
  'ReservationCurrentRecurrentCancelledAttendeeReminder',
  'ReservationCheckinReminder',
  'ReservationNormalToRecurrent',
  'MeetingReservationReminder',
  'MeetingReservationTerminated',
  'MeetingReservationUpdated',
  'MeetingReservationCancelled',
  'MeetingReservationCancellation',
  'DeskReservationCreated',
  'DeskReservationReminder',
  'DeskReservationCancelled',
  'DeskReservationAutoTerminated',
  'SaasTransactionCreditSuccess',
  'SaasRenewSuccess',
  'SaasRenewFailed',
  'SaasSubscriptionExpired',
  'SaasSubscriptionPastDue',
  'SaasSubscriptionTrialExpiring',
  'VisitorRemindApprove',
  'VisitorSendInvite',
  'VisitorSignin',
  'VisitorSignout',
  'VisitorRemind',
  'VisitorLeaveRemind',
  'VisitorExternalAttendeesUpdated',
  'VisitorExternalAttendeesCancelled',
  'VisitorDisapprovedForHost',
  'VisitorApprovedForHost',
  'VisitorSigninForHost',
  'VisitorSigninForCreator',
  'VisitorSatisfactionSurvey',
  'VisitorNotSignout',
  'VisitorAcceptInvitation',
  'VisitorSignNDA',
  'VisitorApprovedForVisitor',
  'VisitorDisapprovedForVisitor',
  'VisitorWatchListRemind',
  'VisitorRequestSuccess',
  'VisitorCancelForHost',
  'VisitorCancelForVisitor',
  'TaskCreatedCreator',
  'TaskCreatedAssignTo',
  'TaskCompleted',
  'TaskExpired',
  'TaskUpdateInfo',
  'TaskRejected',
  'TaskCreatedRecurrentToCreator',
  'BlacklistViolation',
  'BlacklistViolationDepartment',
  'BlacklistViolationInvalid',
  'BlacklistByUserRule',
  'BlacklistByDepartmentRule',
  'BlacklistInvalid',
  'WaitlistCreated',
  'WaitlistPendingConfirm',
  'WaitlistConfirmed',
  'WaitlistTimeOutUnconfirmed',
  'WaitlistByOther',
  'WaitlistFailByRule',
  'WaitlistUpdate',
  'DeliveryCreated',
  'DeliveryExpiredToReceiver',
  'DeliveryExpiredToAssignTo',
  'DeliveryRejected',
  'DeliveryAssignedUpdate',
  'SpaceCreateApply',
  'SpaceCreated',
  'UserCreatedRemind',
  'TaskBeforeExpiredRemind',
  'DeliveryBeforeExpiredRemindToReceiver',
  'DeliveryBeforeExpiredRemindToAssignTo',
  'DeliveryAreaChangeRemind',
  'ApprovalRequestCreated',
  'AutoCheckin',
  'AutoCheckout',
  'AutoCheckinWithoutReservationReminder',
  'OutlookSubscriptionRenewFailed',
  'SpacePlanExpiredRemind',
]
export const enum NotificationTemplateEventNameEnum {
  Test = 'Test',
  SpaceExpiring = 'SpaceExpiring',
  ReservationStartHostReminder = 'ReservationStartHostReminder',
  ReservationStartAttendeeReminder = 'ReservationStartAttendeeReminder',
  ReservationEndSoonReminder = 'ReservationEndSoonReminder',
  ReservationCreatedHostReminder = 'ReservationCreatedHostReminder',
  ReservationCreatedAttendeeReminder = 'ReservationCreatedAttendeeReminder',
  SyncCalendarFailed = 'SyncCalendarFailed',
  ReservationRecurrentCreatedHostReminder = 'ReservationRecurrentCreatedHostReminder',
  ReservationRecurrentCreatedAttendeeReminder = 'ReservationRecurrentCreatedAttendeeReminder',
  ReservationResourceOrTimeUpdated = 'ReservationResourceOrTimeUpdated',
  ReservationHostUpdatedOldHostReminder = 'ReservationHostUpdatedOldHostReminder',
  ReservationHostUpdatedNewHostReminder = 'ReservationHostUpdatedNewHostReminder',
  ReservationAttendeeUpdatedOldAttendeeReminder = 'ReservationAttendeeUpdatedOldAttendeeReminder',
  ReservationAttendeeUpdatedNewAttendeeReminder = 'ReservationAttendeeUpdatedNewAttendeeReminder',
  ReservationAdvanceTerminatedReminder = 'ReservationAdvanceTerminatedReminder',
  ReservationServiceUpdated = 'ReservationServiceUpdated',
  ReservationRecurrentApprovalReminder = 'ReservationRecurrentApprovalReminder',
  ReservationApprovalReminder = 'ReservationApprovalReminder',
  ReservationApprovalPendingReminder = 'ReservationApprovalPendingReminder',
  ReservationApprovalCompleted = 'ReservationApprovalCompleted',
  ReservationCancelledHostReminder = 'ReservationCancelledHostReminder',
  ReservationCancelledAttendeeReminder = 'ReservationCancelledAttendeeReminder',
  ReservationCancelledTaskReminder = 'ReservationCancelledTaskReminder',
  ReservationRecurrentCancelledHostReminder = 'ReservationRecurrentCancelledHostReminder',
  ReservationRecurrentCancelledAttendeeReminder = 'ReservationRecurrentCancelledAttendeeReminder',
  ReservationCurrentRecurrentCancelledHostReminder = 'ReservationCurrentRecurrentCancelledHostReminder',
  ReservationCurrentRecurrentCancelledAttendeeReminder = 'ReservationCurrentRecurrentCancelledAttendeeReminder',
  ReservationCheckinReminder = 'ReservationCheckinReminder',
  ReservationNormalToRecurrent = 'ReservationNormalToRecurrent',
  MeetingReservationReminder = 'MeetingReservationReminder',
  MeetingReservationTerminated = 'MeetingReservationTerminated',
  MeetingReservationUpdated = 'MeetingReservationUpdated',
  MeetingReservationCancelled = 'MeetingReservationCancelled',
  MeetingReservationCancellation = 'MeetingReservationCancellation',
  DeskReservationCreated = 'DeskReservationCreated',
  DeskReservationReminder = 'DeskReservationReminder',
  DeskReservationCancelled = 'DeskReservationCancelled',
  DeskReservationAutoTerminated = 'DeskReservationAutoTerminated',
  SaasTransactionCreditSuccess = 'SaasTransactionCreditSuccess',
  SaasRenewSuccess = 'SaasRenewSuccess',
  SaasRenewFailed = 'SaasRenewFailed',
  SaasSubscriptionExpired = 'SaasSubscriptionExpired',
  SaasSubscriptionPastDue = 'SaasSubscriptionPastDue',
  SaasSubscriptionTrialExpiring = 'SaasSubscriptionTrialExpiring',
  VisitorRemindApprove = 'VisitorRemindApprove',
  VisitorSendInvite = 'VisitorSendInvite',
  VisitorSignin = 'VisitorSignin',
  VisitorSignout = 'VisitorSignout',
  VisitorRemind = 'VisitorRemind',
  VisitorLeaveRemind = 'VisitorLeaveRemind',
  VisitorExternalAttendeesUpdated = 'VisitorExternalAttendeesUpdated',
  VisitorExternalAttendeesCancelled = 'VisitorExternalAttendeesCancelled',
  VisitorDisapprovedForHost = 'VisitorDisapprovedForHost',
  VisitorApprovedForHost = 'VisitorApprovedForHost',
  VisitorSigninForHost = 'VisitorSigninForHost',
  VisitorSigninForCreator = 'VisitorSigninForCreator',
  VisitorSatisfactionSurvey = 'VisitorSatisfactionSurvey',
  VisitorNotSignout = 'VisitorNotSignout',
  VisitorAcceptInvitation = 'VisitorAcceptInvitation',
  VisitorSignNDA = 'VisitorSignNDA',
  VisitorApprovedForVisitor = 'VisitorApprovedForVisitor',
  VisitorDisapprovedForVisitor = 'VisitorDisapprovedForVisitor',
  VisitorWatchListRemind = 'VisitorWatchListRemind',
  VisitorRequestSuccess = 'VisitorRequestSuccess',
  VisitorCancelForHost = 'VisitorCancelForHost',
  VisitorCancelForVisitor = 'VisitorCancelForVisitor',
  TaskCreatedCreator = 'TaskCreatedCreator',
  TaskCreatedAssignTo = 'TaskCreatedAssignTo',
  TaskCompleted = 'TaskCompleted',
  TaskExpired = 'TaskExpired',
  TaskUpdateInfo = 'TaskUpdateInfo',
  TaskRejected = 'TaskRejected',
  TaskCreatedRecurrentToCreator = 'TaskCreatedRecurrentToCreator',
  BlacklistViolation = 'BlacklistViolation',
  BlacklistViolationDepartment = 'BlacklistViolationDepartment',
  BlacklistViolationInvalid = 'BlacklistViolationInvalid',
  BlacklistByUserRule = 'BlacklistByUserRule',
  BlacklistByDepartmentRule = 'BlacklistByDepartmentRule',
  BlacklistInvalid = 'BlacklistInvalid',
  WaitlistCreated = 'WaitlistCreated',
  WaitlistPendingConfirm = 'WaitlistPendingConfirm',
  WaitlistConfirmed = 'WaitlistConfirmed',
  WaitlistTimeOutUnconfirmed = 'WaitlistTimeOutUnconfirmed',
  WaitlistByOther = 'WaitlistByOther',
  WaitlistFailByRule = 'WaitlistFailByRule',
  WaitlistUpdate = 'WaitlistUpdate',
  DeliveryCreated = 'DeliveryCreated',
  DeliveryExpiredToReceiver = 'DeliveryExpiredToReceiver',
  DeliveryExpiredToAssignTo = 'DeliveryExpiredToAssignTo',
  DeliveryRejected = 'DeliveryRejected',
  DeliveryAssignedUpdate = 'DeliveryAssignedUpdate',
  SpaceCreateApply = 'SpaceCreateApply',
  SpaceCreated = 'SpaceCreated',
  UserCreatedRemind = 'UserCreatedRemind',
  TaskBeforeExpiredRemind = 'TaskBeforeExpiredRemind',
  DeliveryBeforeExpiredRemindToReceiver = 'DeliveryBeforeExpiredRemindToReceiver',
  DeliveryBeforeExpiredRemindToAssignTo = 'DeliveryBeforeExpiredRemindToAssignTo',
  DeliveryAreaChangeRemind = 'DeliveryAreaChangeRemind',
  ApprovalRequestCreated = 'ApprovalRequestCreated',
  AutoCheckin = 'AutoCheckin',
  AutoCheckout = 'AutoCheckout',
  AutoCheckinWithoutReservationReminder = 'AutoCheckinWithoutReservationReminder',
  OutlookSubscriptionRenewFailed = 'OutlookSubscriptionRenewFailed',
  SpacePlanExpiredRemind = 'SpacePlanExpiredRemind',
}
export const ApprovalRecordSyncProviderEnumObjects: ModelEnumObjects = {
  qiyeWechat: {
    position: 0,
  },
  dingtalk: {
    position: 1,
  },
}
export const ApprovalRecordSyncProviderEnums = ['qiyeWechat', 'dingtalk']
export const enum ApprovalRecordSyncProviderEnum {
  qiyeWechat = 'qiyeWechat',
  dingtalk = 'dingtalk',
}
export const ApprovalRecordStatusEnumObjects: ModelEnumObjects = {
  approving: {
    color: '--wox-color-alert-warning',
    backgroundColor: '--wox-color-alert-warning-bg',
    icon: 'circle-alert',
    position: 0,
  },
  approved: {
    color: '--wox-color-alert-success',
    backgroundColor: '--wox-color-alert-success-bg',
    icon: 'circle-check',
    position: 1,
  },
  rejected: {
    color: '--wox-color-alert-error',
    backgroundColor: '--wox-color-alert-error-bg',
    icon: 'triangle-alert',
    position: 2,
  },
  terminated: {
    color: '--wox-color-text',
    backgroundColor: '--wox-color-fill-quaternary',
    icon: 'circle-alert',
    position: 3,
  },
}
export const ApprovalRecordStatusEnums = [
  'approving',
  'approved',
  'rejected',
  'terminated',
]
export const enum ApprovalRecordStatusEnum {
  approving = 'approving',
  approved = 'approved',
  rejected = 'rejected',
  terminated = 'terminated',
}
export const ApprovalRecordResourceEnumObjects: ModelEnumObjects = {
  visitor: {
    color: 'gray',
    position: 0,
  },
  resourceReservation: {
    color: 'gray',
    position: 1,
  },
}
export const ApprovalRecordResourceEnums = ['visitor', 'resourceReservation']
export const enum ApprovalRecordResourceEnum {
  visitor = 'visitor',
  resourceReservation = 'resourceReservation',
}
export const CustomFieldTypeEnumObjects: ModelEnumObjects = {
  Text: {
    position: 1,
  },
  Textarea: {
    position: 6,
  },
  Number: {
    position: 7,
  },
  Email: {
    position: 8,
  },
  Phone: {
    position: 9,
  },
  Address: {
    position: 10,
  },
  Select: {
    position: 2,
  },
  MultiSelect: {
    position: 3,
  },
  Checkbox: {
    position: 4,
  },
  Radio: {
    position: 5,
  },
}
export const CustomFieldTypeEnums = [
  'Text',
  'Textarea',
  'Number',
  'Email',
  'Phone',
  'Address',
  'Select',
  'MultiSelect',
  'Checkbox',
  'Radio',
]
export const enum CustomFieldTypeEnum {
  Text = 'Text',
  Textarea = 'Textarea',
  Number = 'Number',
  Email = 'Email',
  Phone = 'Phone',
  Address = 'Address',
  Select = 'Select',
  MultiSelect = 'MultiSelect',
  Checkbox = 'Checkbox',
  Radio = 'Radio',
}
export const CustomFieldOwnerTypeEnumObjects: ModelEnumObjects = {
  UserType: {
    position: 0,
  },
  ResourceType: {
    position: 1,
  },
  VisitorType: {
    position: 2,
  },
  ReservationPolicyType: {
    position: 3,
  },
}
export const CustomFieldOwnerTypeEnums = [
  'UserType',
  'ResourceType',
  'VisitorType',
  'ReservationPolicyType',
]
export const enum CustomFieldOwnerTypeEnum {
  UserType = 'UserType',
  ResourceType = 'ResourceType',
  VisitorType = 'VisitorType',
  ReservationPolicyType = 'ReservationPolicyType',
}
export const DeviceTypeEnumObjects: ModelEnumObjects = {
  android: {
    position: 0,
  },
  ios: {
    position: 1,
  },
}
export const DeviceTypeEnums = ['android', 'ios']
export const enum DeviceTypeEnum {
  android = 'android',
  ios = 'ios',
}
export const EmployeeWorkStatusStateEnumObjects: ModelEnumObjects = {
  WorkOffice: {
    position: 0,
  },
  WorkHome: {
    position: 1,
  },
  Rest: {
    position: 2,
  },
  Unknown: {
    position: 3,
  },
}
export const EmployeeWorkStatusStateEnums = [
  'WorkOffice',
  'WorkHome',
  'Rest',
  'Unknown',
]
export const enum EmployeeWorkStatusStateEnum {
  WorkOffice = 'WorkOffice',
  WorkHome = 'WorkHome',
  Rest = 'Rest',
  Unknown = 'Unknown',
}
export const FeatureNameEnumObjects: ModelEnumObjects = {
  Map: {
    position: 0,
  },
  Dashboard: {
    position: 1,
  },
  WorkStatus: {
    position: 2,
  },
  Delivery: {
    position: 3,
  },
  Task: {
    position: 4,
  },
  Resource: {
    position: 5,
  },
  Announcement: {
    position: 6,
  },
  AppLink: {
    position: 7,
  },
  Visitor: {
    position: 8,
  },
  AddressBook: {
    position: 9,
  },
  OpenApi: {
    position: 10,
  },
  SmartDevice: {
    position: 11,
  },
  Lock: {
    position: 12,
  },
  SSO: {
    position: 13,
  },
  CalendarSync: {
    position: 14,
  },
  TeamsIntegration: {
    position: 15,
  },
  CustomRoles: {
    position: 16,
  },
  AdvancedAnalytics: {
    position: 17,
  },
  AdvancedRules: {
    position: 18,
  },
  SCIM: {
    position: 19,
  },
  MultiLocation: {
    position: 20,
  },
  Hardware: {
    position: 21,
  },
  ApiAccess: {
    position: 22,
  },
  CustomBranding: {
    position: 23,
  },
  SLA: {
    position: 24,
  },
}
export const FeatureNameEnums = [
  'Map',
  'Dashboard',
  'WorkStatus',
  'Delivery',
  'Task',
  'Resource',
  'Announcement',
  'AppLink',
  'Visitor',
  'AddressBook',
  'OpenApi',
  'SmartDevice',
  'Lock',
  'SSO',
  'CalendarSync',
  'TeamsIntegration',
  'CustomRoles',
  'AdvancedAnalytics',
  'AdvancedRules',
  'SCIM',
  'MultiLocation',
  'Hardware',
  'ApiAccess',
  'CustomBranding',
  'SLA',
]
export const enum FeatureNameEnum {
  Map = 'Map',
  Dashboard = 'Dashboard',
  WorkStatus = 'WorkStatus',
  Delivery = 'Delivery',
  Task = 'Task',
  Resource = 'Resource',
  Announcement = 'Announcement',
  AppLink = 'AppLink',
  Visitor = 'Visitor',
  AddressBook = 'AddressBook',
  OpenApi = 'OpenApi',
  SmartDevice = 'SmartDevice',
  Lock = 'Lock',
  SSO = 'SSO',
  CalendarSync = 'CalendarSync',
  TeamsIntegration = 'TeamsIntegration',
  CustomRoles = 'CustomRoles',
  AdvancedAnalytics = 'AdvancedAnalytics',
  AdvancedRules = 'AdvancedRules',
  SCIM = 'SCIM',
  MultiLocation = 'MultiLocation',
  Hardware = 'Hardware',
  ApiAccess = 'ApiAccess',
  CustomBranding = 'CustomBranding',
  SLA = 'SLA',
}
export const AreaUnitEnumObjects: ModelEnumObjects = {
  meter: {
    position: 0,
  },
  foot: {
    position: 1,
  },
}
export const AreaUnitEnums = ['meter', 'foot']
export const enum AreaUnitEnum {
  meter = 'meter',
  foot = 'foot',
}
export const TimeFormatEnumObjects: ModelEnumObjects = {
  Twelve: {
    position: 0,
  },
  TwentyFour: {
    position: 1,
  },
}
export const TimeFormatEnums = ['Twelve', 'TwentyFour']
export const enum TimeFormatEnum {
  Twelve = 'Twelve',
  TwentyFour = 'TwentyFour',
}
export const DashboardTimeModeEnumObjects: ModelEnumObjects = {
  FullDay: {
    position: 0,
  },
  TimeSlot: {
    position: 1,
  },
  HalfDay: {
    position: 2,
  },
  Slot: {
    position: 3,
  },
}
export const DashboardTimeModeEnums = ['FullDay', 'TimeSlot', 'HalfDay', 'Slot']
export const enum DashboardTimeModeEnum {
  FullDay = 'FullDay',
  TimeSlot = 'TimeSlot',
  HalfDay = 'HalfDay',
  Slot = 'Slot',
}
export const PadOSEnumObjects: ModelEnumObjects = {
  android: {
    position: 0,
  },
  ios: {
    position: 1,
  },
}
export const PadOSEnums = ['android', 'ios']
export const enum PadOSEnum {
  android = 'android',
  ios = 'ios',
}
export const PadAppTypeEnumObjects: ModelEnumObjects = {
  visitor: {
    position: 0,
  },
  meetingroom: {
    position: 1,
  },
  office: {
    position: 2,
  },
  panel: {
    position: 3,
  },
  signage: {
    position: 4,
  },
  locker: {
    position: 5,
  },
  meetingroom_pro: {
    position: 6,
  },
}
export const PadAppTypeEnums = [
  'visitor',
  'meetingroom',
  'office',
  'panel',
  'signage',
  'locker',
  'meetingroom_pro',
]
export const enum PadAppTypeEnum {
  visitor = 'visitor',
  meetingroom = 'meetingroom',
  office = 'office',
  panel = 'panel',
  signage = 'signage',
  locker = 'locker',
  meetingroom_pro = 'meetingroom_pro',
}
export const PadSubTypeEnumObjects: ModelEnumObjects = {
  front_desk: {
    position: 0,
  },
  meeting_display: {
    position: 1,
  },
  isaac: {
    position: 2,
  },
  tv_screen: {
    position: 3,
  },
  office_display: {
    position: 4,
  },
  meeting_panel: {
    position: 5,
  },
  office_panel: {
    position: 6,
  },
  digital_signage: {
    position: 7,
  },
  locker: {
    position: 8,
  },
  desk_panel: {
    position: 9,
  },
  pad: {
    position: 10,
  },
  pad_light: {
    position: 11,
  },
  pad_light_all: {
    position: 12,
  },
  visitor_pad: {
    position: 13,
  },
  visitor_machine: {
    position: 14,
  },
  visitor_double_faced: {
    position: 15,
  },
}
export const PadSubTypeEnums = [
  'front_desk',
  'meeting_display',
  'isaac',
  'tv_screen',
  'office_display',
  'meeting_panel',
  'office_panel',
  'digital_signage',
  'locker',
  'desk_panel',
  'pad',
  'pad_light',
  'pad_light_all',
  'visitor_pad',
  'visitor_machine',
  'visitor_double_faced',
]
export const enum PadSubTypeEnum {
  front_desk = 'front_desk',
  meeting_display = 'meeting_display',
  isaac = 'isaac',
  tv_screen = 'tv_screen',
  office_display = 'office_display',
  meeting_panel = 'meeting_panel',
  office_panel = 'office_panel',
  digital_signage = 'digital_signage',
  locker = 'locker',
  desk_panel = 'desk_panel',
  pad = 'pad',
  pad_light = 'pad_light',
  pad_light_all = 'pad_light_all',
  visitor_pad = 'visitor_pad',
  visitor_machine = 'visitor_machine',
  visitor_double_faced = 'visitor_double_faced',
}
export const PadLockTypeEnumObjects: ModelEnumObjects = {
  serial: {
    position: 0,
  },
  usb: {
    position: 1,
  },
  remote: {
    position: 2,
  },
  io: {
    position: 3,
  },
}
export const PadLockTypeEnums = ['serial', 'usb', 'remote', 'io']
export const enum PadLockTypeEnum {
  serial = 'serial',
  usb = 'usb',
  remote = 'remote',
  io = 'io',
}
export const PadStateEnumObjects: ModelEnumObjects = {
  enabled: {
    color: 'green',
    position: 0,
  },
  disabled: {
    color: 'red',
    position: 1,
  },
}
export const PadStateEnums = ['enabled', 'disabled']
export const enum PadStateEnum {
  enabled = 'enabled',
  disabled = 'disabled',
}
export const PadUpgradeStatusEnumObjects: ModelEnumObjects = {
  has_new_version: {
    position: 0,
  },
  no_new_version: {
    position: 1,
  },
  upgrading: {
    position: 2,
  },
}
export const PadUpgradeStatusEnums = [
  'has_new_version',
  'no_new_version',
  'upgrading',
]
export const enum PadUpgradeStatusEnum {
  has_new_version = 'has_new_version',
  no_new_version = 'no_new_version',
  upgrading = 'upgrading',
}
export const VisitorPadAssetableTypeEnumObjects: ModelEnumObjects = {
  FloorInfo: {
    position: 0,
  },
  Location: {
    position: 1,
  },
  Area: {
    position: 2,
  },
}
export const VisitorPadAssetableTypeEnums = ['FloorInfo', 'Location', 'Area']
export const enum VisitorPadAssetableTypeEnum {
  FloorInfo = 'FloorInfo',
  Location = 'Location',
  Area = 'Area',
}
export const PadCommunicationModeEnumObjects: ModelEnumObjects = {
  socket: {
    position: 0,
  },
  iot: {
    position: 1,
  },
  all: {
    position: 2,
  },
}
export const PadCommunicationModeEnums = ['socket', 'iot', 'all']
export const enum PadCommunicationModeEnum {
  socket = 'socket',
  iot = 'iot',
  all = 'all',
}
export const OpenDoorModeEnumObjects: ModelEnumObjects = {
  USB: {
    position: 0,
  },
  SerialPort: {
    position: 1,
  },
}
export const OpenDoorModeEnums = ['USB', 'SerialPort']
export const enum OpenDoorModeEnum {
  USB = 'USB',
  SerialPort = 'SerialPort',
}
export const AreaTypeEnumObjects: ModelEnumObjects = {
  delivery: {
    position: 0,
  },
  other: {
    position: 1,
  },
}
export const AreaTypeEnums = ['delivery', 'other']
export const enum AreaTypeEnum {
  delivery = 'delivery',
  other = 'other',
}
export const RoleLevelEnumObjects: ModelEnumObjects = {
  SPACE: {
    position: 0,
  },
  LOCATION: {
    position: 1,
  },
}
export const RoleLevelEnums = ['SPACE', 'LOCATION']
export const enum RoleLevelEnum {
  SPACE = 'SPACE',
  LOCATION = 'LOCATION',
}
export const PermissionTypeEnumObjects: ModelEnumObjects = {
  ONLY_SPACE: {
    position: 0,
  },
  ONLY_LOCATION: {
    position: 1,
  },
  ALL: {
    position: 2,
  },
}
export const PermissionTypeEnums = ['ONLY_SPACE', 'ONLY_LOCATION', 'ALL']
export const enum PermissionTypeEnum {
  ONLY_SPACE = 'ONLY_SPACE',
  ONLY_LOCATION = 'ONLY_LOCATION',
  ALL = 'ALL',
}
export const CustomerPlanLevelEnumObjects: ModelEnumObjects = {
  Team: {
    position: 0,
  },
  Premium: {
    color: 'blue',
    position: 1,
  },
  Enterprise: {
    color: 'orange',
    position: 2,
  },
  Free: {
    position: 3,
  },
}
export const CustomerPlanLevelEnums = ['Team', 'Premium', 'Enterprise', 'Free']
export const enum CustomerPlanLevelEnum {
  Team = 'Team',
  Premium = 'Premium',
  Enterprise = 'Enterprise',
  Free = 'Free',
}
export const CustomerPlanTypeEnumObjects: ModelEnumObjects = {
  Visitor: {
    position: 0,
  },
  ExclusiveResources: {
    color: 'blue',
    position: 1,
  },
  SharedResources: {
    color: 'orange',
    position: 2,
  },
}
export const CustomerPlanTypeEnums = [
  'Visitor',
  'ExclusiveResources',
  'SharedResources',
]
export const enum CustomerPlanTypeEnum {
  Visitor = 'Visitor',
  ExclusiveResources = 'ExclusiveResources',
  SharedResources = 'SharedResources',
}
export const CustomerPricingIntervalEnumObjects: ModelEnumObjects = {
  Monthly: {
    position: 0,
  },
  Yearly: {
    position: 1,
  },
}
export const CustomerPricingIntervalEnums = ['Monthly', 'Yearly']
export const enum CustomerPricingIntervalEnum {
  Monthly = 'Monthly',
  Yearly = 'Yearly',
}
export const CustomerSubscriptionStatusEnumObjects: ModelEnumObjects = {
  Inactive: {
    color: 'red',
    position: 0,
  },
  Active: {
    color: 'green',
    position: 1,
  },
  Suspended: {
    color: '#D1D5DB',
    position: 2,
  },
  Canceled: {
    color: '#D1D5DB',
    position: 3,
  },
}
export const CustomerSubscriptionStatusEnums = [
  'Inactive',
  'Active',
  'Suspended',
  'Canceled',
]
export const enum CustomerSubscriptionStatusEnum {
  Inactive = 'Inactive',
  Active = 'Active',
  Suspended = 'Suspended',
  Canceled = 'Canceled',
}
export const ServiceTimeEnumObjects: ModelEnumObjects = {
  before_reservation: {
    color: 'description-gray',
    icon: 'alarm-clock',
    position: 0,
  },
  after_reservation: {
    color: 'description-gray',
    icon: 'alarm-clock',
    position: 1,
  },
  within_reservation: {
    color: 'description-gray',
    icon: 'alarm-clock',
    position: 2,
  },
}
export const ServiceTimeEnums = [
  'before_reservation',
  'after_reservation',
  'within_reservation',
]
export const enum ServiceTimeEnum {
  before_reservation = 'before_reservation',
  after_reservation = 'after_reservation',
  within_reservation = 'within_reservation',
}
export const SpaceStatusEnumObjects: ModelEnumObjects = {
  active: {
    position: 0,
  },
  init: {
    position: 1,
  },
  rejected: {
    position: 2,
  },
}
export const SpaceStatusEnums = ['active', 'init', 'rejected']
export const enum SpaceStatusEnum {
  active = 'active',
  init = 'init',
  rejected = 'rejected',
}
export const SpaceLevelEnumObjects: ModelEnumObjects = {
  Standard: {
    position: 0,
  },
  Premium: {
    position: 1,
  },
  Enterprise: {
    position: 2,
  },
  Free: {
    position: 3,
  },
}
export const SpaceLevelEnums = ['Standard', 'Premium', 'Enterprise', 'Free']
export const enum SpaceLevelEnum {
  Standard = 'Standard',
  Premium = 'Premium',
  Enterprise = 'Enterprise',
  Free = 'Free',
}
export const TrialStatusEnumObjects: ModelEnumObjects = {
  NONE: {
    position: 0,
  },
  ACTIVE: {
    position: 1,
  },
  EXPIRING: {
    position: 2,
  },
  EXPIRED: {
    position: 3,
  },
  CONVERTED: {
    position: 4,
  },
  CHURNED: {
    position: 5,
  },
}
export const TrialStatusEnums = [
  'NONE',
  'ACTIVE',
  'EXPIRING',
  'EXPIRED',
  'CONVERTED',
  'CHURNED',
]
export const enum TrialStatusEnum {
  NONE = 'NONE',
  ACTIVE = 'ACTIVE',
  EXPIRING = 'EXPIRING',
  EXPIRED = 'EXPIRED',
  CONVERTED = 'CONVERTED',
  CHURNED = 'CHURNED',
}
export const PricingTierEnumObjects: ModelEnumObjects = {
  TRIAL: {
    position: 0,
  },
  SANDBOX: {
    position: 1,
  },
  STARTER: {
    position: 2,
  },
  PREMIUM: {
    position: 3,
  },
  ENTERPRISE: {
    position: 4,
  },
}
export const PricingTierEnums = [
  'TRIAL',
  'SANDBOX',
  'STARTER',
  'PREMIUM',
  'ENTERPRISE',
]
export const enum PricingTierEnum {
  TRIAL = 'TRIAL',
  SANDBOX = 'SANDBOX',
  STARTER = 'STARTER',
  PREMIUM = 'PREMIUM',
  ENTERPRISE = 'ENTERPRISE',
}
export const BillingCycleEnumObjects: ModelEnumObjects = {
  MONTHLY: {
    position: 0,
  },
  ANNUAL: {
    position: 1,
  },
}
export const BillingCycleEnums = ['MONTHLY', 'ANNUAL']
export const enum BillingCycleEnum {
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
}
export const TaskCategoryTypeEnumObjects: ModelEnumObjects = {
  Repair: {
    position: 0,
  },
  Meeting: {
    position: 1,
  },
  Cleaning: {
    position: 2,
  },
  Other: {
    position: 3,
  },
}
export const TaskCategoryTypeEnums = ['Repair', 'Meeting', 'Cleaning', 'Other']
export const enum TaskCategoryTypeEnum {
  Repair = 'Repair',
  Meeting = 'Meeting',
  Cleaning = 'Cleaning',
  Other = 'Other',
}
export const UserStateEnumObjects: ModelEnumObjects = {
  unconfirmed: {
    color: 'orange',
    position: 0,
  },
  active: {
    color: 'green',
    position: 1,
  },
  dismissed: {
    color: 'red',
    position: 2,
  },
}
export const UserStateEnums = ['unconfirmed', 'active', 'dismissed']
export const enum UserStateEnum {
  unconfirmed = 'unconfirmed',
  active = 'active',
  dismissed = 'dismissed',
}
export const UserGenderEnumObjects: ModelEnumObjects = {
  notSet: {
    position: 0,
  },
  male: {
    position: 1,
  },
  female: {
    position: 2,
  },
}
export const UserGenderEnums = ['notSet', 'male', 'female']
export const enum UserGenderEnum {
  notSet = 'notSet',
  male = 'male',
  female = 'female',
}
export const UserEmployeeTypeEnumObjects: ModelEnumObjects = {
  fulltime: {
    position: 0,
  },
  parttime: {
    position: 1,
  },
  contractor: {
    position: 2,
  },
  external: {
    position: 3,
  },
}
export const UserEmployeeTypeEnums = [
  'fulltime',
  'parttime',
  'contractor',
  'external',
]
export const enum UserEmployeeTypeEnum {
  fulltime = 'fulltime',
  parttime = 'parttime',
  contractor = 'contractor',
  external = 'external',
}
export const UserSyncProviderTypeEnumObjects: ModelEnumObjects = {
  SCIM: {
    position: 0,
  },
  GOOGLE_DIRECTORY: {
    position: 1,
  },
  MICROSOFT_ENTRA_ID: {
    position: 2,
  },
  WECOM: {
    position: 3,
  },
  RWORK: {
    position: 4,
  },
}
export const UserSyncProviderTypeEnums = [
  'SCIM',
  'GOOGLE_DIRECTORY',
  'MICROSOFT_ENTRA_ID',
  'WECOM',
  'RWORK',
]
export const enum UserSyncProviderTypeEnum {
  SCIM = 'SCIM',
  GOOGLE_DIRECTORY = 'GOOGLE_DIRECTORY',
  MICROSOFT_ENTRA_ID = 'MICROSOFT_ENTRA_ID',
  WECOM = 'WECOM',
  RWORK = 'RWORK',
}
export const ObjectAuditTypeEnumObjects: ModelEnumObjects = {
  User: {
    position: 0,
  },
  Resource: {
    position: 1,
  },
  ResourceReservation: {
    position: 2,
  },
  Task: {
    position: 3,
  },
  Visitor: {
    position: 4,
  },
  Delivery: {
    position: 5,
  },
  ResourceType: {
    position: 6,
  },
  SmartDevice: {
    position: 7,
  },
  Permission: {
    position: 8,
  },
  ApiKey: {
    position: 9,
  },
  SecurityConfig: {
    position: 10,
  },
  DataExport: {
    position: 11,
  },
  ScimSync: {
    position: 12,
  },
}
export const ObjectAuditTypeEnums = [
  'User',
  'Resource',
  'ResourceReservation',
  'Task',
  'Visitor',
  'Delivery',
  'ResourceType',
  'SmartDevice',
  'Permission',
  'ApiKey',
  'SecurityConfig',
  'DataExport',
  'ScimSync',
]
export const enum ObjectAuditTypeEnum {
  User = 'User',
  Resource = 'Resource',
  ResourceReservation = 'ResourceReservation',
  Task = 'Task',
  Visitor = 'Visitor',
  Delivery = 'Delivery',
  ResourceType = 'ResourceType',
  SmartDevice = 'SmartDevice',
  Permission = 'Permission',
  ApiKey = 'ApiKey',
  SecurityConfig = 'SecurityConfig',
  DataExport = 'DataExport',
  ScimSync = 'ScimSync',
}
export const ObjectAuditActionEnumObjects: ModelEnumObjects = {
  Create: {
    position: 0,
  },
  Update: {
    position: 1,
  },
  Delete: {
    position: 2,
  },
  Login: {
    position: 3,
  },
  Logout: {
    position: 4,
  },
  ChangePassword: {
    position: 5,
  },
  LoginFailed: {
    position: 6,
  },
  Sync: {
    position: 7,
  },
  SyncFailed: {
    position: 8,
  },
  Grant: {
    position: 9,
  },
  Revoke: {
    position: 10,
  },
  Export: {
    position: 11,
  },
  BulkExport: {
    position: 12,
  },
}
export const ObjectAuditActionEnums = [
  'Create',
  'Update',
  'Delete',
  'Login',
  'Logout',
  'ChangePassword',
  'LoginFailed',
  'Sync',
  'SyncFailed',
  'Grant',
  'Revoke',
  'Export',
  'BulkExport',
]
export const enum ObjectAuditActionEnum {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
  Login = 'Login',
  Logout = 'Logout',
  ChangePassword = 'ChangePassword',
  LoginFailed = 'LoginFailed',
  Sync = 'Sync',
  SyncFailed = 'SyncFailed',
  Grant = 'Grant',
  Revoke = 'Revoke',
  Export = 'Export',
  BulkExport = 'BulkExport',
}
export const SecurityAuditActionEnumObjects: ModelEnumObjects = {
  Login: {
    position: 0,
  },
  Logout: {
    position: 1,
  },
  LoginFailed: {
    position: 2,
  },
  LoginInvalidPassword: {
    position: 3,
  },
}
export const SecurityAuditActionEnums = [
  'Login',
  'Logout',
  'LoginFailed',
  'LoginInvalidPassword',
]
export const enum SecurityAuditActionEnum {
  Login = 'Login',
  Logout = 'Logout',
  LoginFailed = 'LoginFailed',
  LoginInvalidPassword = 'LoginInvalidPassword',
}
export const SecurityAuditClientTypeEnumObjects: ModelEnumObjects = {
  Web: {
    position: 0,
  },
  AdminPortal: {
    position: 1,
  },
  VisitorPortal: {
    position: 2,
  },
  App: {
    position: 3,
  },
  Outlook: {
    position: 4,
  },
  GoogleCalendar: {
    position: 5,
  },
  Cron: {
    position: 6,
  },
  Queue: {
    position: 7,
  },
  VisitorPad: {
    position: 8,
  },
  MeetingPad: {
    position: 9,
  },
  PartnerApi: {
    position: 10,
  },
  Ops: {
    position: 11,
  },
  SmartDevice: {
    position: 12,
  },
  Desktop: {
    position: 13,
  },
  Lock: {
    position: 14,
  },
  OpenApi: {
    position: 15,
  },
}
export const SecurityAuditClientTypeEnums = [
  'Web',
  'AdminPortal',
  'VisitorPortal',
  'App',
  'Outlook',
  'GoogleCalendar',
  'Cron',
  'Queue',
  'VisitorPad',
  'MeetingPad',
  'PartnerApi',
  'Ops',
  'SmartDevice',
  'Desktop',
  'Lock',
  'OpenApi',
]
export const enum SecurityAuditClientTypeEnum {
  Web = 'Web',
  AdminPortal = 'AdminPortal',
  VisitorPortal = 'VisitorPortal',
  App = 'App',
  Outlook = 'Outlook',
  GoogleCalendar = 'GoogleCalendar',
  Cron = 'Cron',
  Queue = 'Queue',
  VisitorPad = 'VisitorPad',
  MeetingPad = 'MeetingPad',
  PartnerApi = 'PartnerApi',
  Ops = 'Ops',
  SmartDevice = 'SmartDevice',
  Desktop = 'Desktop',
  Lock = 'Lock',
  OpenApi = 'OpenApi',
}
export const VisitorBlockItemTypeEnumObjects: ModelEnumObjects = {
  blacklist: {
    position: 0,
  },
  watchlist: {
    position: 1,
  },
}
export const VisitorBlockItemTypeEnums = ['blacklist', 'watchlist']
export const enum VisitorBlockItemTypeEnum {
  blacklist = 'blacklist',
  watchlist = 'watchlist',
}
export const VisitorBlockKeywordTypeEnumObjects: ModelEnumObjects = {
  phone_num: {
    color: 'gray',
    icon: 'smartphone',
    position: 0,
  },
  email: {
    color: 'gray',
    icon: 'mail',
    position: 1,
  },
  name: {
    color: 'gray',
    icon: 'user',
    position: 2,
  },
  company: {
    color: 'gray',
    icon: 'building-2',
    position: 3,
  },
}
export const VisitorBlockKeywordTypeEnums = [
  'phone_num',
  'email',
  'name',
  'company',
]
export const enum VisitorBlockKeywordTypeEnum {
  phone_num = 'phone_num',
  email = 'email',
  name = 'name',
  company = 'company',
}
export const VisitorPurposeEnumObjects: ModelEnumObjects = {
  BUSINESS: {
    position: 0,
  },
  CONTRACTOR: {
    position: 1,
  },
  INTERVIEW: {
    position: 2,
  },
  DELIVERY: {
    position: 3,
  },
  PERSONAL: {
    position: 4,
  },
  MEETING: {
    position: 5,
  },
  EVENT: {
    position: 6,
  },
  OTHER: {
    position: 7,
  },
}
export const VisitorPurposeEnums = [
  'BUSINESS',
  'CONTRACTOR',
  'INTERVIEW',
  'DELIVERY',
  'PERSONAL',
  'MEETING',
  'EVENT',
  'OTHER',
]
export const enum VisitorPurposeEnum {
  BUSINESS = 'BUSINESS',
  CONTRACTOR = 'CONTRACTOR',
  INTERVIEW = 'INTERVIEW',
  DELIVERY = 'DELIVERY',
  PERSONAL = 'PERSONAL',
  MEETING = 'MEETING',
  EVENT = 'EVENT',
  OTHER = 'OTHER',
}
export const InviteSectionTypeEnumObjects: ModelEnumObjects = {
  wifi: {
    position: 0,
  },
  lobby: {
    position: 1,
  },
  restroom: {
    position: 2,
  },
  storage: {
    position: 3,
  },
  waiting: {
    position: 4,
  },
  emergency: {
    position: 5,
  },
  beverage: {
    position: 6,
  },
  sign_out: {
    position: 7,
  },
  other: {
    position: 8,
  },
}
export const InviteSectionTypeEnums = [
  'wifi',
  'lobby',
  'restroom',
  'storage',
  'waiting',
  'emergency',
  'beverage',
  'sign_out',
  'other',
]
export const enum InviteSectionTypeEnum {
  wifi = 'wifi',
  lobby = 'lobby',
  restroom = 'restroom',
  storage = 'storage',
  waiting = 'waiting',
  emergency = 'emergency',
  beverage = 'beverage',
  sign_out = 'sign_out',
  other = 'other',
}
export const SignInSectionTypeEnumObjects: ModelEnumObjects = {
  traffic: {
    position: 0,
  },
  park: {
    position: 1,
  },
  elevator: {
    position: 2,
  },
  proscenium: {
    position: 3,
  },
  necessity: {
    position: 4,
  },
}
export const SignInSectionTypeEnums = [
  'traffic',
  'park',
  'elevator',
  'proscenium',
  'necessity',
]
export const enum SignInSectionTypeEnum {
  traffic = 'traffic',
  park = 'park',
  elevator = 'elevator',
  proscenium = 'proscenium',
  necessity = 'necessity',
}
export const GuideTypeEnumObjects: ModelEnumObjects = {
  invite: {
    position: 0,
  },
  sign_in: {
    position: 1,
  },
}
export const GuideTypeEnums = ['invite', 'sign_in']
export const enum GuideTypeEnum {
  invite = 'invite',
  sign_in = 'sign_in',
}
export const LawAgreementStatusEnumObjects: ModelEnumObjects = {
  enabled: {
    color: 'green',
    position: 0,
  },
  disabled: {
    color: 'red',
    position: 1,
  },
}
export const LawAgreementStatusEnums = ['enabled', 'disabled']
export const enum LawAgreementStatusEnum {
  enabled = 'enabled',
  disabled = 'disabled',
}
export const LawAgreementTypeEnumObjects: ModelEnumObjects = {
  html: {
    position: 0,
  },
  pdf: {
    position: 1,
  },
}
export const LawAgreementTypeEnums = ['html', 'pdf']
export const enum LawAgreementTypeEnum {
  html = 'html',
  pdf = 'pdf',
}
export const VisitorEmailNotificationStatusEnumObjects: ModelEnumObjects = {
  sending: {
    position: 0,
  },
  sent: {
    position: 1,
  },
  sent_error: {
    position: 2,
  },
  soft_bounce: {
    position: 3,
  },
  deliver: {
    position: 4,
  },
  open: {
    position: 5,
  },
  click: {
    position: 6,
  },
  invalid: {
    position: 7,
  },
  report_spam: {
    position: 8,
  },
}
export const VisitorEmailNotificationStatusEnums = [
  'sending',
  'sent',
  'sent_error',
  'soft_bounce',
  'deliver',
  'open',
  'click',
  'invalid',
  'report_spam',
]
export const enum VisitorEmailNotificationStatusEnum {
  sending = 'sending',
  sent = 'sent',
  sent_error = 'sent_error',
  soft_bounce = 'soft_bounce',
  deliver = 'deliver',
  open = 'open',
  click = 'click',
  invalid = 'invalid',
  report_spam = 'report_spam',
}
export const VisitorSmsNotificationStatusEnumObjects: ModelEnumObjects = {
  sending: {
    position: 0,
  },
  sent: {
    position: 1,
  },
  success: {
    position: 2,
  },
  bounced: {
    position: 3,
  },
}
export const VisitorSmsNotificationStatusEnums = [
  'sending',
  'sent',
  'success',
  'bounced',
]
export const enum VisitorSmsNotificationStatusEnum {
  sending = 'sending',
  sent = 'sent',
  success = 'success',
  bounced = 'bounced',
}
export const VisitorIdTypeEnumObjects: ModelEnumObjects = {
  none: {
    position: 0,
  },
  person_identification_card: {
    position: 1,
  },
  passport: {
    position: 2,
  },
  foreign_passport: {
    position: 3,
  },
  hk_or_macao_card: {
    position: 4,
  },
}
export const VisitorIdTypeEnums = [
  'none',
  'person_identification_card',
  'passport',
  'foreign_passport',
  'hk_or_macao_card',
]
export const enum VisitorIdTypeEnum {
  none = 'none',
  person_identification_card = 'person_identification_card',
  passport = 'passport',
  foreign_passport = 'foreign_passport',
  hk_or_macao_card = 'hk_or_macao_card',
}
export const VisitorIdCheckedSourceEnumObjects: ModelEnumObjects = {
  none: {
    position: 0,
  },
  manual: {
    position: 1,
  },
  pad: {
    position: 2,
  },
}
export const VisitorIdCheckedSourceEnums = ['none', 'manual', 'pad']
export const enum VisitorIdCheckedSourceEnum {
  none = 'none',
  manual = 'manual',
  pad = 'pad',
}
export const VisitorCategoryEnumObjects: ModelEnumObjects = {
  visitor: {
    position: 0,
  },
  employee: {
    position: 1,
  },
}
export const VisitorCategoryEnums = ['visitor', 'employee']
export const enum VisitorCategoryEnum {
  visitor = 'visitor',
  employee = 'employee',
}
export const VisitorUnifiedStatusEnumObjects: ModelEnumObjects = {
  approving: {
    color: '--wox-color-alert-warning',
    backgroundColor: '--wox-color-alert-warning-bg',
    icon: 'info',
    position: 0,
  },
  waiting_for_acceptance: {
    color: '--wox-color-alert-info',
    backgroundColor: '--wox-color-alert-info-bg',
    icon: 'info',
    position: 1,
  },
  waiting_for_sign: {
    color: '--wox-color-alert-warning',
    backgroundColor: '--wox-color-alert-warning-bg',
    icon: 'clock',
    position: 2,
  },
  signed_in: {
    color: '--wox-color-alert-success',
    backgroundColor: '--wox-color-alert-success-bg',
    icon: 'circle-check',
    position: 3,
  },
  signed_out: {
    color: '--wox-color-text',
    backgroundColor: '--wox-color-fill-quaternary',
    icon: 'check',
    position: 4,
  },
  cancelled: {
    color: '--wox-color-text',
    backgroundColor: '--wox-color-fill-quaternary',
    icon: 'circle-x',
    position: 5,
  },
}
export const VisitorUnifiedStatusEnums = [
  'approving',
  'waiting_for_acceptance',
  'waiting_for_sign',
  'signed_in',
  'signed_out',
  'cancelled',
]
export const enum VisitorUnifiedStatusEnum {
  approving = 'approving',
  waiting_for_acceptance = 'waiting_for_acceptance',
  waiting_for_sign = 'waiting_for_sign',
  signed_in = 'signed_in',
  signed_out = 'signed_out',
  cancelled = 'cancelled',
}
export const VisitorCancelReasonEnumObjects: ModelEnumObjects = {
  admin_cancel: {
    position: 0,
  },
  self_cancel: {
    position: 1,
  },
  approve_reject: {
    position: 2,
  },
  auto_cancel: {
    position: 3,
  },
  visitor_reject: {
    position: 4,
  },
}
export const VisitorCancelReasonEnums = [
  'admin_cancel',
  'self_cancel',
  'approve_reject',
  'auto_cancel',
  'visitor_reject',
]
export const enum VisitorCancelReasonEnum {
  admin_cancel = 'admin_cancel',
  self_cancel = 'self_cancel',
  approve_reject = 'approve_reject',
  auto_cancel = 'auto_cancel',
  visitor_reject = 'visitor_reject',
}
export const VisitorRequestTypeEnumObjects: ModelEnumObjects = {
  request: {
    position: 0,
  },
  invite: {
    position: 1,
  },
}
export const VisitorRequestTypeEnums = ['request', 'invite']
export const enum VisitorRequestTypeEnum {
  request = 'request',
  invite = 'invite',
}
export const VisitorRecurrenceTypeEnumObjects: ModelEnumObjects = {
  Occurance: {
    position: 0,
  },
  Exception: {
    position: 1,
  },
}
export const VisitorRecurrenceTypeEnums = ['Occurance', 'Exception']
export const enum VisitorRecurrenceTypeEnum {
  Occurance = 'Occurance',
  Exception = 'Exception',
}
export const VisitorRecordCycleTypeEnumObjects: ModelEnumObjects = {
  Daily: {
    position: 0,
  },
  Monthly: {
    position: 1,
  },
  Hourly: {
    position: 2,
  },
}
export const VisitorRecordCycleTypeEnums = ['Daily', 'Monthly', 'Hourly']
export const enum VisitorRecordCycleTypeEnum {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Hourly = 'Hourly',
}
export const WebhookEventEnumObjects: ModelEnumObjects = {
  Ping: {
    position: 0,
  },
  Reservation: {
    position: 1,
  },
  Visitor: {
    position: 2,
  },
  Task: {
    position: 3,
  },
  Delivery: {
    position: 4,
  },
}
export const WebhookEventEnums = [
  'Ping',
  'Reservation',
  'Visitor',
  'Task',
  'Delivery',
]
export const enum WebhookEventEnum {
  Ping = 'Ping',
  Reservation = 'Reservation',
  Visitor = 'Visitor',
  Task = 'Task',
  Delivery = 'Delivery',
}
export const WebhookEventStatusEnumObjects: ModelEnumObjects = {
  Success: {
    color: 'green',
    position: 0,
  },
  Failed: {
    color: 'red',
    position: 1,
  },
}
export const WebhookEventStatusEnums = ['Success', 'Failed']
export const enum WebhookEventStatusEnum {
  Success = 'Success',
  Failed = 'Failed',
}
export const HolidayTypeEnumObjects: ModelEnumObjects = {
  public: {
    position: 0,
  },
  bank: {
    position: 1,
  },
  school: {
    position: 2,
  },
  optional: {
    position: 3,
  },
  observance: {
    position: 4,
  },
}
export const HolidayTypeEnums = [
  'public',
  'bank',
  'school',
  'optional',
  'observance',
]
export const enum HolidayTypeEnum {
  public = 'public',
  bank = 'bank',
  school = 'school',
  optional = 'optional',
  observance = 'observance',
}
export const ResourceListOrderTypeEnumObjects: ModelEnumObjects = {
  Resource: {
    position: 0,
  },
  ReservationRecord: {
    position: 1,
  },
  ReservationWaitlist: {
    position: 2,
  },
}
export const ResourceListOrderTypeEnums = [
  'Resource',
  'ReservationRecord',
  'ReservationWaitlist',
]
export const enum ResourceListOrderTypeEnum {
  Resource = 'Resource',
  ReservationRecord = 'ReservationRecord',
  ReservationWaitlist = 'ReservationWaitlist',
}
export const ResourceUsageModeEnumObjects: ModelEnumObjects = {
  shareable: {
    icon: 'users',
    position: 0,
  },
  exclusive: {
    icon: 'user',
    position: 1,
  },
}
export const ResourceUsageModeEnums = ['shareable', 'exclusive']
export const enum ResourceUsageModeEnum {
  shareable = 'shareable',
  exclusive = 'exclusive',
}
export const CustomFieldSourceTypeEnumObjects: ModelEnumObjects = {
  User: {
    position: 0,
  },
  Resource: {
    position: 1,
  },
  Visitor: {
    position: 2,
  },
  Reservation: {
    position: 3,
  },
}
export const CustomFieldSourceTypeEnums = [
  'User',
  'Resource',
  'Visitor',
  'Reservation',
]
export const enum CustomFieldSourceTypeEnum {
  User = 'User',
  Resource = 'Resource',
  Visitor = 'Visitor',
  Reservation = 'Reservation',
}
export const ResourceStateEnumObjects: ModelEnumObjects = {
  free: {
    color: 'green',
    position: 0,
  },
  occupied: {
    color: 'blue',
    position: 1,
  },
  unknown: {
    color: 'gray',
    position: 2,
  },
}
export const ResourceStateEnums = ['free', 'occupied', 'unknown']
export const enum ResourceStateEnum {
  free = 'free',
  occupied = 'occupied',
  unknown = 'unknown',
}
export const ReservationTypeEnumObjects: ModelEnumObjects = {
  Reservation: {
    position: 0,
  },
  Service: {
    position: 1,
  },
  Block: {
    position: 2,
  },
}
export const ReservationTypeEnums = ['Reservation', 'Service', 'Block']
export const enum ReservationTypeEnum {
  Reservation = 'Reservation',
  Service = 'Service',
  Block = 'Block',
}
export const ReservationRecurrenceTypeEnumObjects: ModelEnumObjects = {
  Occurance: {
    position: 0,
  },
  Exception: {
    position: 1,
  },
}
export const ReservationRecurrenceTypeEnums = ['Occurance', 'Exception']
export const enum ReservationRecurrenceTypeEnum {
  Occurance = 'Occurance',
  Exception = 'Exception',
}
export const ReservationStatusEnumObjects: ModelEnumObjects = {
  approving: {
    color: 'orange',
    backgroundColor: '#F97316',
    position: 0,
  },
  reserved: {
    color: 'blue',
    backgroundColor: '#9CA3AF',
    position: 1,
  },
  upcoming: {
    color: 'blue',
    backgroundColor: '#3B82F6',
    position: 2,
  },
  starting_soon: {
    color: 'cyan',
    backgroundColor: '#06B6D4',
    position: 3,
  },
  ongoing: {
    color: 'green',
    backgroundColor: '#10B981',
    position: 4,
  },
  ending_soon: {
    color: 'pink',
    backgroundColor: '#EC4899',
    position: 5,
  },
  terminated: {
    color: 'gray',
    backgroundColor: '#9CA3AF',
    position: 6,
  },
  cancelled: {
    color: 'gray',
    backgroundColor: '#9CA3AF',
    position: 7,
  },
}
export const ReservationStatusEnums = [
  'approving',
  'reserved',
  'upcoming',
  'starting_soon',
  'ongoing',
  'ending_soon',
  'terminated',
  'cancelled',
]
export const enum ReservationStatusEnum {
  approving = 'approving',
  reserved = 'reserved',
  upcoming = 'upcoming',
  starting_soon = 'starting_soon',
  ongoing = 'ongoing',
  ending_soon = 'ending_soon',
  terminated = 'terminated',
  cancelled = 'cancelled',
}
export const ReservationStatusIconEnumObjects: ModelEnumObjects = {
  approving: {
    color: '--wox-color-alert-warning',
    backgroundColor: '--wox-color-alert-warning-bg',
    icon: 'circle-alert',
    position: 0,
  },
  reserved: {
    color: '--wox-color-alert-info',
    backgroundColor: '--wox-color-alert-info-bg',
    icon: 'circle-check',
    position: 1,
  },
  upcoming: {
    color: '--wox-color-alert-success',
    backgroundColor: '--wox-color-alert-success-bg',
    icon: 'circle-check',
    position: 2,
  },
  starting_soon: {
    color: '--wox-color-alert-info',
    backgroundColor: '--wox-color-alert-info-bg',
    icon: 'info',
    position: 3,
  },
  ongoing: {
    color: '--wox-color-alert-success',
    backgroundColor: '--wox-color-alert-success-bg',
    icon: 'clock',
    position: 4,
  },
  ending_soon: {
    color: '--wox-color-alert-warning',
    backgroundColor: '--wox-color-alert-warning-bg',
    icon: 'clock',
    position: 5,
  },
  terminated: {
    color: '--wox-color-text',
    backgroundColor: '--wox-color-fill-quaternary',
    icon: 'clock',
    position: 6,
  },
  cancelled: {
    color: '--wox-color-text',
    backgroundColor: '--wox-color-fill-quaternary',
    icon: 'info',
    position: 7,
  },
}
export const ReservationStatusIconEnums = [
  'approving',
  'reserved',
  'upcoming',
  'starting_soon',
  'ongoing',
  'ending_soon',
  'terminated',
  'cancelled',
]
export const enum ReservationStatusIconEnum {
  approving = 'approving',
  reserved = 'reserved',
  upcoming = 'upcoming',
  starting_soon = 'starting_soon',
  ongoing = 'ongoing',
  ending_soon = 'ending_soon',
  terminated = 'terminated',
  cancelled = 'cancelled',
}
export const ReservationTimeModeEnumObjects: ModelEnumObjects = {
  free: {
    position: 0,
  },
  fullDay: {
    position: 1,
  },
  slot: {
    position: 2,
  },
}
export const ReservationTimeModeEnums = ['free', 'fullDay', 'slot']
export const enum ReservationTimeModeEnum {
  free = 'free',
  fullDay = 'fullDay',
  slot = 'slot',
}
export const BookingModeEnumObjects: ModelEnumObjects = {
  free: {
    position: 0,
  },
  fullDay: {
    position: 1,
  },
  slot: {
    position: 2,
  },
}
export const BookingModeEnums = ['free', 'fullDay', 'slot']
export const enum BookingModeEnum {
  free = 'free',
  fullDay = 'fullDay',
  slot = 'slot',
}
export const AttendeeStatusEnumObjects: ModelEnumObjects = {
  not_reply: {
    position: 0,
  },
  attend: {
    position: 1,
  },
  not_attend: {
    position: 2,
  },
  possible_attend: {
    position: 3,
  },
}
export const AttendeeStatusEnums = [
  'not_reply',
  'attend',
  'not_attend',
  'possible_attend',
]
export const enum AttendeeStatusEnum {
  not_reply = 'not_reply',
  attend = 'attend',
  not_attend = 'not_attend',
  possible_attend = 'possible_attend',
}
export const AttendeeRoleEnumObjects: ModelEnumObjects = {
  host: {
    color: 'pink',
    position: 0,
  },
  participant: {
    position: 1,
  },
  cc: {
    position: 2,
  },
}
export const AttendeeRoleEnums = ['host', 'participant', 'cc']
export const enum AttendeeRoleEnum {
  host = 'host',
  participant = 'participant',
  cc = 'cc',
}
export const TaskPriorityEnumObjects: ModelEnumObjects = {
  None: {
    color: 'gray',
    icon: 'x',
    position: 0,
  },
  Low: {
    color: 'gray',
    icon: 'x',
    position: 1,
  },
  Normal: {
    color: 'gray',
    icon: 'ellipsis',
    position: 2,
  },
  High: {
    color: 'red',
    icon: 'x',
    position: 3,
  },
  Urgent: {
    color: 'red',
    icon: 'check',
    position: 4,
  },
}
export const TaskPriorityEnums = ['None', 'Low', 'Normal', 'High', 'Urgent']
export const enum TaskPriorityEnum {
  None = 'None',
  Low = 'Low',
  Normal = 'Normal',
  High = 'High',
  Urgent = 'Urgent',
}
export const TaskStateEnumObjects: ModelEnumObjects = {
  Pending: {
    color: '--wox-color-alert-warning',
    backgroundColor: '--wox-color-alert-warning-bg',
    icon: 'clock',
    position: 0,
  },
  Received: {
    color: '--wox-color-alert-info',
    backgroundColor: '--wox-color-alert-info-bg',
    icon: 'circle-check',
    position: 1,
  },
  Completed: {
    color: '--wox-color-alert-success',
    backgroundColor: '--wox-color-alert-success-bg',
    icon: 'circle-check',
    position: 2,
  },
  Rejected: {
    color: '--wox-color-alert-error',
    backgroundColor: '--wox-color-alert-error-bg',
    icon: 'triangle-alert',
    position: 3,
  },
}
export const TaskStateEnums = ['Pending', 'Received', 'Completed', 'Rejected']
export const enum TaskStateEnum {
  Pending = 'Pending',
  Received = 'Received',
  Completed = 'Completed',
  Rejected = 'Rejected',
}
export const DeliveryPriorityEnumObjects: ModelEnumObjects = {
  None: {
    color: 'gray',
    icon: 'x',
    position: 0,
  },
  Low: {
    color: 'gray',
    icon: 'x',
    position: 1,
  },
  Normal: {
    color: 'gray',
    icon: 'ellipsis',
    position: 2,
  },
  High: {
    color: 'red',
    icon: 'x',
    position: 3,
  },
  Urgent: {
    color: 'red',
    icon: 'check',
    position: 4,
  },
}
export const DeliveryPriorityEnums = ['None', 'Low', 'Normal', 'High', 'Urgent']
export const enum DeliveryPriorityEnum {
  None = 'None',
  Low = 'Low',
  Normal = 'Normal',
  High = 'High',
  Urgent = 'Urgent',
}
export const DeliveryStateEnumObjects: ModelEnumObjects = {
  Pending: {
    color: '--wox-color-alert-warning',
    backgroundColor: '--wox-color-alert-warning-bg',
    icon: 'clock',
    position: 0,
  },
  PickedUp: {
    color: '--wox-color-alert-success',
    backgroundColor: '--wox-color-alert-success-bg',
    icon: 'circle-check',
    position: 1,
  },
  Rejected: {
    color: '--wox-color-alert-error',
    backgroundColor: '--wox-color-alert-error-bg',
    icon: 'triangle-alert',
    position: 2,
  },
}
export const DeliveryStateEnums = ['Pending', 'PickedUp', 'Rejected']
export const enum DeliveryStateEnum {
  Pending = 'Pending',
  PickedUp = 'PickedUp',
  Rejected = 'Rejected',
}
export const CalendarTypeEnumObjects: ModelEnumObjects = {
  Google: {
    position: 0,
  },
  Outlook: {
    position: 1,
  },
}
export const CalendarTypeEnums = ['Google', 'Outlook']
export const enum CalendarTypeEnum {
  Google = 'Google',
  Outlook = 'Outlook',
}
export const EmailTrackingTypeEnumObjects: ModelEnumObjects = {
  Reservation: {
    position: 0,
  },
  Visitor: {
    position: 1,
  },
  Task: {
    position: 2,
  },
  Delivery: {
    position: 3,
  },
  approval: {
    position: 4,
  },
  Blacklist: {
    position: 5,
  },
  Waitlist: {
    position: 6,
  },
  User: {
    position: 7,
  },
}
export const EmailTrackingTypeEnums = [
  'Reservation',
  'Visitor',
  'Task',
  'Delivery',
  'approval',
  'Blacklist',
  'Waitlist',
  'User',
]
export const enum EmailTrackingTypeEnum {
  Reservation = 'Reservation',
  Visitor = 'Visitor',
  Task = 'Task',
  Delivery = 'Delivery',
  approval = 'approval',
  Blacklist = 'Blacklist',
  Waitlist = 'Waitlist',
  User = 'User',
}
export const EmailRecordStatusEnumObjects: ModelEnumObjects = {
  OPENED: {
    position: 0,
  },
  REJECTED: {
    position: 1,
  },
  SENT: {
    position: 2,
  },
  DEFERRED: {
    position: 3,
  },
  DELIVERED: {
    position: 4,
  },
  BOUNCED: {
    position: 5,
  },
  DROPPED: {
    position: 6,
  },
  CLICKED: {
    position: 7,
  },
  BLOCKED: {
    position: 8,
  },
  SPAM: {
    position: 9,
  },
  UNSUBSCRIBED: {
    position: 10,
  },
  DELAYED: {
    position: 11,
  },
  COMPLAINT: {
    position: 12,
  },
  UNKNOWN: {
    position: 13,
  },
}
export const EmailRecordStatusEnums = [
  'OPENED',
  'REJECTED',
  'SENT',
  'DEFERRED',
  'DELIVERED',
  'BOUNCED',
  'DROPPED',
  'CLICKED',
  'BLOCKED',
  'SPAM',
  'UNSUBSCRIBED',
  'DELAYED',
  'COMPLAINT',
  'UNKNOWN',
]
export const enum EmailRecordStatusEnum {
  OPENED = 'OPENED',
  REJECTED = 'REJECTED',
  SENT = 'SENT',
  DEFERRED = 'DEFERRED',
  DELIVERED = 'DELIVERED',
  BOUNCED = 'BOUNCED',
  DROPPED = 'DROPPED',
  CLICKED = 'CLICKED',
  BLOCKED = 'BLOCKED',
  SPAM = 'SPAM',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
  DELAYED = 'DELAYED',
  COMPLAINT = 'COMPLAINT',
  UNKNOWN = 'UNKNOWN',
}
export const ExternalCalendarSubscriptionRenewStatusEnumObjects: ModelEnumObjects =
  {
    Success: {
      color: 'green',
      position: 0,
    },
    Error: {
      color: 'red',
      position: 1,
    },
  }
export const ExternalCalendarSubscriptionRenewStatusEnums = ['Success', 'Error']
export const enum ExternalCalendarSubscriptionRenewStatusEnum {
  Success = 'Success',
  Error = 'Error',
}
export const AppCategoryEnumObjects: ModelEnumObjects = {
  SSO: {
    icon: 'log-in',
    position: 1,
  },
  Calendar: {
    icon: 'calendar-days',
    position: 2,
  },
  FileStorage: {
    icon: 'folder',
    position: 3,
  },
  Directory: {
    icon: 'layout-list',
    position: 4,
  },
  HR: {
    icon: 'users',
    position: 5,
  },
  OA: {
    icon: 'monitor',
    position: 6,
  },
  Automation: {
    icon: 'refresh-cw',
    position: 7,
  },
  VideoMeeting: {
    icon: 'square-play',
    position: 8,
  },
  Notifications: {
    icon: 'bell',
    position: 9,
  },
  SmartHardware: {
    icon: 'cpu',
    position: 10,
  },
  Analytics: {
    icon: 'layout-grid',
    position: 11,
  },
  Other: {
    icon: 'layout-grid',
    position: 12,
  },
}
export const AppCategoryEnums = [
  'SSO',
  'Calendar',
  'FileStorage',
  'Directory',
  'HR',
  'OA',
  'Automation',
  'VideoMeeting',
  'Notifications',
  'SmartHardware',
  'Analytics',
  'Other',
]
export const enum AppCategoryEnum {
  SSO = 'SSO',
  Calendar = 'Calendar',
  FileStorage = 'FileStorage',
  Directory = 'Directory',
  HR = 'HR',
  OA = 'OA',
  Automation = 'Automation',
  VideoMeeting = 'VideoMeeting',
  Notifications = 'Notifications',
  SmartHardware = 'SmartHardware',
  Analytics = 'Analytics',
  Other = 'Other',
}
export const CalendarSyncDirectionEnumObjects: ModelEnumObjects = {
  Inbound: {
    position: 0,
  },
  Outbound: {
    position: 1,
  },
}
export const CalendarSyncDirectionEnums = ['Inbound', 'Outbound']
export const enum CalendarSyncDirectionEnum {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
}
export const CalendarSyncStatusEnumObjects: ModelEnumObjects = {
  Success: {
    color: '--wox-color-alert-success',
    backgroundColor: '--wox-color-alert-success-bg',
    icon: 'circle-check',
    position: 0,
  },
  Error: {
    color: '--wox-color-alert-error',
    backgroundColor: '--wox-color-alert-error-bg',
    icon: 'circle-x',
    position: 1,
  },
}
export const CalendarSyncStatusEnums = ['Success', 'Error']
export const enum CalendarSyncStatusEnum {
  Success = 'Success',
  Error = 'Error',
}
export const CalendarSyncActionEnumObjects: ModelEnumObjects = {
  Create: {
    position: 0,
  },
  Update: {
    position: 1,
  },
  Delete: {
    position: 2,
  },
  Skip: {
    position: 3,
  },
}
export const CalendarSyncActionEnums = ['Create', 'Update', 'Delete', 'Skip']
export const enum CalendarSyncActionEnum {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
  Skip = 'Skip',
}
export const PolicyTypeEnumObjects: ModelEnumObjects = {
  ReservationReserveRule: {
    position: 0,
  },
  ReservationUpdateRule: {
    position: 1,
  },
  ReservationCheckInRule: {
    position: 2,
  },
  ReservationSecurityRule: {
    position: 3,
  },
  ReservationFormRule: {
    position: 4,
  },
  ReservationBlacklistRule: {
    position: 5,
  },
  TReservationServiceRule: {
    position: 6,
  },
  ReservationDeviceRule: {
    position: 7,
  },
}
export const PolicyTypeEnums = [
  'ReservationReserveRule',
  'ReservationUpdateRule',
  'ReservationCheckInRule',
  'ReservationSecurityRule',
  'ReservationFormRule',
  'ReservationBlacklistRule',
  'TReservationServiceRule',
  'ReservationDeviceRule',
]
export const enum PolicyTypeEnum {
  ReservationReserveRule = 'ReservationReserveRule',
  ReservationUpdateRule = 'ReservationUpdateRule',
  ReservationCheckInRule = 'ReservationCheckInRule',
  ReservationSecurityRule = 'ReservationSecurityRule',
  ReservationFormRule = 'ReservationFormRule',
  ReservationBlacklistRule = 'ReservationBlacklistRule',
  TReservationServiceRule = 'TReservationServiceRule',
  ReservationDeviceRule = 'ReservationDeviceRule',
}
export const ViolationTypeEnumObjects: ModelEnumObjects = {
  reserved_not_usage_count: {
    position: 0,
  },
  reserved_not_usage_minutes: {
    position: 1,
  },
}
export const ViolationTypeEnums = [
  'reserved_not_usage_count',
  'reserved_not_usage_minutes',
]
export const enum ViolationTypeEnum {
  reserved_not_usage_count = 'reserved_not_usage_count',
  reserved_not_usage_minutes = 'reserved_not_usage_minutes',
}
export const ViolationStatusEnumObjects: ModelEnumObjects = {
  active: {
    color: '--wox-color-alert-success',
    backgroundColor: '--wox-color-alert-success-bg',
    icon: 'circle-check',
    position: 0,
  },
  inactive: {
    color: '--wox-color-text',
    backgroundColor: '--wox-color-fill-quaternary',
    icon: 'circle-x',
    position: 1,
  },
}
export const ViolationStatusEnums = ['active', 'inactive']
export const enum ViolationStatusEnum {
  active = 'active',
  inactive = 'inactive',
}
export const BlacklistTypeEnumObjects: ModelEnumObjects = {
  user: {
    position: 0,
  },
  department: {
    position: 1,
  },
}
export const BlacklistTypeEnums = ['user', 'department']
export const enum BlacklistTypeEnum {
  user = 'user',
  department = 'department',
}
export const BlacklistSourceEnumObjects: ModelEnumObjects = {
  system: {
    position: 0,
  },
  admin: {
    position: 1,
  },
}
export const BlacklistSourceEnums = ['system', 'admin']
export const enum BlacklistSourceEnum {
  system = 'system',
  admin = 'admin',
}
export const BlacklistStatusEnumObjects: ModelEnumObjects = {
  effective: {
    color: '--wox-color-alert-success',
    backgroundColor: '--wox-color-alert-success-bg',
    icon: 'circle-check',
    position: 0,
  },
  unEffective: {
    color: '--wox-color-alert-warning',
    backgroundColor: '--wox-color-alert-warning-bg',
    icon: 'clock',
    position: 1,
  },
  expired: {
    color: '--wox-color-text',
    backgroundColor: '--wox-color-fill-quaternary',
    icon: 'circle-x',
    position: 2,
  },
}
export const BlacklistStatusEnums = ['effective', 'unEffective', 'expired']
export const enum BlacklistStatusEnum {
  effective = 'effective',
  unEffective = 'unEffective',
  expired = 'expired',
}
export const BlacklistOperationEnumObjects: ModelEnumObjects = {
  add_to_blacklist: {
    position: 0,
  },
  remove_from_blacklist: {
    position: 1,
  },
}
export const BlacklistOperationEnums = [
  'add_to_blacklist',
  'remove_from_blacklist',
]
export const enum BlacklistOperationEnum {
  add_to_blacklist = 'add_to_blacklist',
  remove_from_blacklist = 'remove_from_blacklist',
}
export const WaitlistStatusEnumObjects: ModelEnumObjects = {
  pending: {
    color: 'orange',
    icon: 'circle-ellipsis',
    position: 0,
  },
  pending_confirm: {
    color: 'blue',
    icon: 'circle-ellipsis',
    position: 1,
  },
  confirmed: {
    color: 'green',
    icon: 'circle-check',
    position: 2,
  },
  cancelled: {
    color: 'gray',
    icon: 'circle-x',
    position: 3,
  },
  failed: {
    color: 'gray',
    icon: 'circle-x',
    position: 4,
  },
}
export const WaitlistStatusEnums = [
  'pending',
  'pending_confirm',
  'confirmed',
  'cancelled',
  'failed',
]
export const enum WaitlistStatusEnum {
  pending = 'pending',
  pending_confirm = 'pending_confirm',
  confirmed = 'confirmed',
  cancelled = 'cancelled',
  failed = 'failed',
}
export const WaitlistStatusIconEnumObjects: ModelEnumObjects = {
  pending: {
    color: '--wox-color-alert-warning',
    backgroundColor: '--wox-color-alert-warning-bg',
    icon: 'clock',
    position: 0,
  },
  pending_confirm: {
    color: '--wox-color-alert-info',
    backgroundColor: '--wox-color-alert-info-bg',
    icon: 'info',
    position: 1,
  },
  confirmed: {
    color: '--wox-color-alert-success',
    backgroundColor: '--wox-color-alert-success-bg',
    icon: 'circle-check',
    position: 2,
  },
  cancelled: {
    color: '--wox-color-text',
    backgroundColor: '--wox-color-fill-quaternary',
    icon: 'info',
    position: 3,
  },
  failed: {
    color: '--wox-color-text',
    backgroundColor: '--wox-color-fill-quaternary',
    icon: 'info',
    position: 4,
  },
}
export const WaitlistStatusIconEnums = [
  'pending',
  'pending_confirm',
  'confirmed',
  'cancelled',
  'failed',
]
export const enum WaitlistStatusIconEnum {
  pending = 'pending',
  pending_confirm = 'pending_confirm',
  confirmed = 'confirmed',
  cancelled = 'cancelled',
  failed = 'failed',
}
export const EndReasonEnumObjects: ModelEnumObjects = {
  cancel_by_self: {
    position: 0,
  },
  timeout_unconfirmed: {
    position: 1,
  },
  waited_reservation_ended_normally: {
    position: 2,
  },
  waited_reservation_reserved_by_other: {
    position: 3,
  },
  waited_reservation_reserve_failed: {
    position: 4,
  },
  waitlist_reservation_cron_cancelled: {
    position: 5,
  },
  cancel_waitlist_reservation_by_self: {
    position: 6,
  },
  cancel_by_admin: {
    position: 7,
  },
  cancel_waitlist_reservation_by_admin: {
    position: 8,
  },
}
export const EndReasonEnums = [
  'cancel_by_self',
  'timeout_unconfirmed',
  'waited_reservation_ended_normally',
  'waited_reservation_reserved_by_other',
  'waited_reservation_reserve_failed',
  'waitlist_reservation_cron_cancelled',
  'cancel_waitlist_reservation_by_self',
  'cancel_by_admin',
  'cancel_waitlist_reservation_by_admin',
]
export const enum EndReasonEnum {
  cancel_by_self = 'cancel_by_self',
  timeout_unconfirmed = 'timeout_unconfirmed',
  waited_reservation_ended_normally = 'waited_reservation_ended_normally',
  waited_reservation_reserved_by_other = 'waited_reservation_reserved_by_other',
  waited_reservation_reserve_failed = 'waited_reservation_reserve_failed',
  waitlist_reservation_cron_cancelled = 'waitlist_reservation_cron_cancelled',
  cancel_waitlist_reservation_by_self = 'cancel_waitlist_reservation_by_self',
  cancel_by_admin = 'cancel_by_admin',
  cancel_waitlist_reservation_by_admin = 'cancel_waitlist_reservation_by_admin',
}
export const SmartDevicePowerTypeEnumObjects: ModelEnumObjects = {
  power_supply: {
    position: 0,
  },
  battery: {
    position: 1,
  },
}
export const SmartDevicePowerTypeEnums = ['power_supply', 'battery']
export const enum SmartDevicePowerTypeEnum {
  power_supply = 'power_supply',
  battery = 'battery',
}
export const SmartDeviceBrandEnumObjects: ModelEnumObjects = {
  kuban: {
    position: 0,
  },
  life_smart: {
    position: 1,
  },
  gewu: {
    position: 2,
  },
  hikvision: {
    position: 3,
  },
  zkong: {
    position: 4,
  },
  kaiterra: {
    position: 5,
  },
  yunding: {
    position: 6,
  },
  idtk: {
    position: 7,
  },
  crestron: {
    position: 8,
  },
}
export const SmartDeviceBrandEnums = [
  'kuban',
  'life_smart',
  'gewu',
  'hikvision',
  'zkong',
  'kaiterra',
  'yunding',
  'idtk',
  'crestron',
]
export const enum SmartDeviceBrandEnum {
  kuban = 'kuban',
  life_smart = 'life_smart',
  gewu = 'gewu',
  hikvision = 'hikvision',
  zkong = 'zkong',
  kaiterra = 'kaiterra',
  yunding = 'yunding',
  idtk = 'idtk',
  crestron = 'crestron',
}
export const SmartDeviceTypeEnumObjects: ModelEnumObjects = {
  human_sensor: {
    position: 0,
  },
  actuator: {
    position: 1,
  },
  people_counter: {
    position: 2,
  },
  air: {
    position: 3,
  },
  air_conditioner: {
    position: 4,
  },
  curtain: {
    position: 5,
  },
  gateway: {
    position: 6,
  },
  ink_screen: {
    position: 7,
  },
  electric_meter: {
    position: 8,
  },
  smoke_sensor: {
    position: 9,
  },
}
export const SmartDeviceTypeEnums = [
  'human_sensor',
  'actuator',
  'people_counter',
  'air',
  'air_conditioner',
  'curtain',
  'gateway',
  'ink_screen',
  'electric_meter',
  'smoke_sensor',
]
export const enum SmartDeviceTypeEnum {
  human_sensor = 'human_sensor',
  actuator = 'actuator',
  people_counter = 'people_counter',
  air = 'air',
  air_conditioner = 'air_conditioner',
  curtain = 'curtain',
  gateway = 'gateway',
  ink_screen = 'ink_screen',
  electric_meter = 'electric_meter',
  smoke_sensor = 'smoke_sensor',
}
export const SmartDeviceAssetableTypeEnumObjects: ModelEnumObjects = {
  Resource: {
    position: 0,
  },
  FloorInfo: {
    position: 1,
  },
  Location: {
    position: 2,
  },
  Area: {
    position: 3,
  },
}
export const SmartDeviceAssetableTypeEnums = [
  'Resource',
  'FloorInfo',
  'Location',
  'Area',
]
export const enum SmartDeviceAssetableTypeEnum {
  Resource = 'Resource',
  FloorInfo = 'FloorInfo',
  Location = 'Location',
  Area = 'Area',
}
export const SmartDeviceSubtypeEnumObjects: ModelEnumObjects = {
  SL_CP_AIR: {
    position: 0,
  },
  SL_SF_RC: {
    position: 1,
  },
  SL_SW_RC: {
    position: 2,
  },
  SL_SW_IF3: {
    position: 3,
  },
  SL_SF_IF3: {
    position: 4,
  },
  SL_SW_CP3: {
    position: 5,
  },
  SL_SW_RC3: {
    position: 6,
  },
  SL_SW_IF2: {
    position: 7,
  },
  SL_SF_IF2: {
    position: 8,
  },
  SL_SW_CP2: {
    position: 9,
  },
  SL_SW_FE2: {
    position: 10,
  },
  SL_SW_RC2: {
    position: 11,
  },
  SL_SW_IF1: {
    position: 12,
  },
  SL_SF_IF1: {
    position: 13,
  },
  SL_SW_CP1: {
    position: 14,
  },
  SL_SW_FE1: {
    position: 15,
  },
  SL_SW_RC1: {
    position: 16,
  },
  SL_OL_W: {
    position: 17,
  },
  SL_NATURE: {
    position: 18,
  },
  SL_SC_BM: {
    position: 19,
  },
  SL_SC_MHW: {
    position: 20,
  },
  SL_SC_CM: {
    position: 21,
  },
  SL_SC_THL: {
    position: 22,
  },
  SL_SC_BE: {
    position: 23,
  },
  SL_SC_CQ: {
    position: 24,
  },
  SL_DOOYA: {
    position: 25,
  },
  SL_SC_CA: {
    position: 26,
  },
  V_SI: {
    position: 27,
  },
  SL_SW_NS1: {
    position: 28,
  },
  SL_SW_NS2: {
    position: 29,
  },
  SL_SW_NS3: {
    position: 30,
  },
  SL_SC_CH: {
    position: 31,
  },
  SL_SC_CN: {
    position: 32,
  },
  SL_SW_ND3: {
    position: 33,
  },
  SL_SW_ND2: {
    position: 34,
  },
  SL_SW_ND1: {
    position: 35,
  },
  SL_MC_ND3: {
    position: 36,
  },
  SL_MC_ND2: {
    position: 37,
  },
  SL_MC_ND1: {
    position: 38,
  },
  SL_SW_BS1: {
    position: 39,
  },
  SL_SW_BS2: {
    position: 40,
  },
  SL_SW_BS3: {
    position: 41,
  },
  SL_SW_MJ1: {
    position: 42,
  },
  SL_SW_MJ2: {
    position: 43,
  },
  SL_SW_MJ3: {
    position: 44,
  },
  SL_OE_3C: {
    position: 45,
  },
  SL_OE_DE: {
    position: 46,
  },
  SL_OE_W: {
    position: 47,
  },
  ZG_PMT300_S_ZTN: {
    position: 48,
  },
  ZG_HE200_ZB: {
    position: 49,
  },
  ZG_MIR_SM100_E: {
    position: 50,
  },
}
export const SmartDeviceSubtypeEnums = [
  'SL_CP_AIR',
  'SL_SF_RC',
  'SL_SW_RC',
  'SL_SW_IF3',
  'SL_SF_IF3',
  'SL_SW_CP3',
  'SL_SW_RC3',
  'SL_SW_IF2',
  'SL_SF_IF2',
  'SL_SW_CP2',
  'SL_SW_FE2',
  'SL_SW_RC2',
  'SL_SW_IF1',
  'SL_SF_IF1',
  'SL_SW_CP1',
  'SL_SW_FE1',
  'SL_SW_RC1',
  'SL_OL_W',
  'SL_NATURE',
  'SL_SC_BM',
  'SL_SC_MHW',
  'SL_SC_CM',
  'SL_SC_THL',
  'SL_SC_BE',
  'SL_SC_CQ',
  'SL_DOOYA',
  'SL_SC_CA',
  'V_SI',
  'SL_SW_NS1',
  'SL_SW_NS2',
  'SL_SW_NS3',
  'SL_SC_CH',
  'SL_SC_CN',
  'SL_SW_ND3',
  'SL_SW_ND2',
  'SL_SW_ND1',
  'SL_MC_ND3',
  'SL_MC_ND2',
  'SL_MC_ND1',
  'SL_SW_BS1',
  'SL_SW_BS2',
  'SL_SW_BS3',
  'SL_SW_MJ1',
  'SL_SW_MJ2',
  'SL_SW_MJ3',
  'SL_OE_3C',
  'SL_OE_DE',
  'SL_OE_W',
  'ZG_PMT300_S_ZTN',
  'ZG_HE200_ZB',
  'ZG_MIR_SM100_E',
]
export const enum SmartDeviceSubtypeEnum {
  SL_CP_AIR = 'SL_CP_AIR',
  SL_SF_RC = 'SL_SF_RC',
  SL_SW_RC = 'SL_SW_RC',
  SL_SW_IF3 = 'SL_SW_IF3',
  SL_SF_IF3 = 'SL_SF_IF3',
  SL_SW_CP3 = 'SL_SW_CP3',
  SL_SW_RC3 = 'SL_SW_RC3',
  SL_SW_IF2 = 'SL_SW_IF2',
  SL_SF_IF2 = 'SL_SF_IF2',
  SL_SW_CP2 = 'SL_SW_CP2',
  SL_SW_FE2 = 'SL_SW_FE2',
  SL_SW_RC2 = 'SL_SW_RC2',
  SL_SW_IF1 = 'SL_SW_IF1',
  SL_SF_IF1 = 'SL_SF_IF1',
  SL_SW_CP1 = 'SL_SW_CP1',
  SL_SW_FE1 = 'SL_SW_FE1',
  SL_SW_RC1 = 'SL_SW_RC1',
  SL_OL_W = 'SL_OL_W',
  SL_NATURE = 'SL_NATURE',
  SL_SC_BM = 'SL_SC_BM',
  SL_SC_MHW = 'SL_SC_MHW',
  SL_SC_CM = 'SL_SC_CM',
  SL_SC_THL = 'SL_SC_THL',
  SL_SC_BE = 'SL_SC_BE',
  SL_SC_CQ = 'SL_SC_CQ',
  SL_DOOYA = 'SL_DOOYA',
  SL_SC_CA = 'SL_SC_CA',
  V_SI = 'V_SI',
  SL_SW_NS1 = 'SL_SW_NS1',
  SL_SW_NS2 = 'SL_SW_NS2',
  SL_SW_NS3 = 'SL_SW_NS3',
  SL_SC_CH = 'SL_SC_CH',
  SL_SC_CN = 'SL_SC_CN',
  SL_SW_ND3 = 'SL_SW_ND3',
  SL_SW_ND2 = 'SL_SW_ND2',
  SL_SW_ND1 = 'SL_SW_ND1',
  SL_MC_ND3 = 'SL_MC_ND3',
  SL_MC_ND2 = 'SL_MC_ND2',
  SL_MC_ND1 = 'SL_MC_ND1',
  SL_SW_BS1 = 'SL_SW_BS1',
  SL_SW_BS2 = 'SL_SW_BS2',
  SL_SW_BS3 = 'SL_SW_BS3',
  SL_SW_MJ1 = 'SL_SW_MJ1',
  SL_SW_MJ2 = 'SL_SW_MJ2',
  SL_SW_MJ3 = 'SL_SW_MJ3',
  SL_OE_3C = 'SL_OE_3C',
  SL_OE_DE = 'SL_OE_DE',
  SL_OE_W = 'SL_OE_W',
  ZG_PMT300_S_ZTN = 'ZG_PMT300_S_ZTN',
  ZG_HE200_ZB = 'ZG_HE200_ZB',
  ZG_MIR_SM100_E = 'ZG_MIR_SM100_E',
}
export const SmartDeviceSampleStateEnumObjects: ModelEnumObjects = {
  SUCCESS: {
    position: 0,
  },
  FAIL: {
    position: 1,
  },
}
export const SmartDeviceSampleStateEnums = ['SUCCESS', 'FAIL']
export const enum SmartDeviceSampleStateEnum {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}
export const SmartDeviceSampleVariableEnumObjects: ModelEnumObjects = {
  temperature: {
    position: 0,
  },
  humidity: {
    position: 1,
  },
  tvoc: {
    position: 2,
  },
  co2: {
    position: 3,
  },
  ch2o: {
    position: 4,
  },
  pm25: {
    position: 5,
  },
  illuminance: {
    position: 6,
  },
  sound_pressure: {
    position: 7,
  },
  pm1: {
    position: 8,
  },
  pm10: {
    position: 9,
  },
  pm100: {
    position: 10,
  },
  outdoor_pm25: {
    position: 11,
  },
  alarm: {
    position: 12,
  },
  sound_alarm: {
    position: 13,
  },
  smoke_alarm: {
    position: 14,
  },
  cigarette_alarm: {
    position: 15,
  },
  curtain_state: {
    position: 16,
  },
  curtain_direction: {
    position: 17,
  },
  curtain_percent: {
    position: 18,
  },
  swi: {
    position: 19,
  },
  ch2o_overload: {
    position: 20,
  },
  nh3: {
    position: 21,
  },
  h2s: {
    position: 22,
  },
  pwr: {
    position: 23,
  },
  pwr_consumption: {
    position: 24,
  },
  pwr_load: {
    position: 25,
  },
  pwr_max_load: {
    position: 26,
  },
  ppc: {
    position: 27,
  },
  hb: {
    position: 28,
  },
  ac_valve: {
    position: 29,
  },
  ac_valve1: {
    position: 30,
  },
  ac_valve2: {
    position: 31,
  },
  ac_device_type: {
    position: 32,
  },
  ac_cfg: {
    position: 33,
  },
  ac_target_speed: {
    position: 34,
  },
  ac_current_speed: {
    position: 35,
  },
  ac_current_temperature: {
    position: 36,
  },
  ac_target_temperature: {
    position: 37,
  },
  ac_mode: {
    position: 38,
  },
  on_off: {
    position: 39,
  },
  aqi: {
    position: 40,
  },
  color: {
    position: 41,
  },
  brightness: {
    position: 42,
  },
  pressure: {
    position: 43,
  },
  battery: {
    position: 44,
  },
  voltage: {
    position: 45,
  },
  ch2o_limit: {
    position: 46,
  },
  ch2o_warning_voice: {
    position: 47,
  },
  occupancy: {
    position: 48,
  },
  software: {
    position: 49,
  },
  hardware: {
    position: 50,
  },
  set_mode: {
    position: 51,
  },
  set_on: {
    position: 52,
  },
  set_off: {
    position: 53,
  },
  set_value: {
    position: 54,
  },
  set_ac_mode: {
    position: 55,
  },
  set_ac_speed: {
    position: 56,
  },
  set_ac_temperature: {
    position: 57,
  },
  set_ink_sync: {
    position: 58,
  },
}
export const SmartDeviceSampleVariableEnums = [
  'temperature',
  'humidity',
  'tvoc',
  'co2',
  'ch2o',
  'pm25',
  'illuminance',
  'sound_pressure',
  'pm1',
  'pm10',
  'pm100',
  'outdoor_pm25',
  'alarm',
  'sound_alarm',
  'smoke_alarm',
  'cigarette_alarm',
  'curtain_state',
  'curtain_direction',
  'curtain_percent',
  'swi',
  'ch2o_overload',
  'nh3',
  'h2s',
  'pwr',
  'pwr_consumption',
  'pwr_load',
  'pwr_max_load',
  'ppc',
  'hb',
  'ac_valve',
  'ac_valve1',
  'ac_valve2',
  'ac_device_type',
  'ac_cfg',
  'ac_target_speed',
  'ac_current_speed',
  'ac_current_temperature',
  'ac_target_temperature',
  'ac_mode',
  'on_off',
  'aqi',
  'color',
  'brightness',
  'pressure',
  'battery',
  'voltage',
  'ch2o_limit',
  'ch2o_warning_voice',
  'occupancy',
  'software',
  'hardware',
  'set_mode',
  'set_on',
  'set_off',
  'set_value',
  'set_ac_mode',
  'set_ac_speed',
  'set_ac_temperature',
  'set_ink_sync',
]
export const enum SmartDeviceSampleVariableEnum {
  temperature = 'temperature',
  humidity = 'humidity',
  tvoc = 'tvoc',
  co2 = 'co2',
  ch2o = 'ch2o',
  pm25 = 'pm25',
  illuminance = 'illuminance',
  sound_pressure = 'sound_pressure',
  pm1 = 'pm1',
  pm10 = 'pm10',
  pm100 = 'pm100',
  outdoor_pm25 = 'outdoor_pm25',
  alarm = 'alarm',
  sound_alarm = 'sound_alarm',
  smoke_alarm = 'smoke_alarm',
  cigarette_alarm = 'cigarette_alarm',
  curtain_state = 'curtain_state',
  curtain_direction = 'curtain_direction',
  curtain_percent = 'curtain_percent',
  swi = 'swi',
  ch2o_overload = 'ch2o_overload',
  nh3 = 'nh3',
  h2s = 'h2s',
  pwr = 'pwr',
  pwr_consumption = 'pwr_consumption',
  pwr_load = 'pwr_load',
  pwr_max_load = 'pwr_max_load',
  ppc = 'ppc',
  hb = 'hb',
  ac_valve = 'ac_valve',
  ac_valve1 = 'ac_valve1',
  ac_valve2 = 'ac_valve2',
  ac_device_type = 'ac_device_type',
  ac_cfg = 'ac_cfg',
  ac_target_speed = 'ac_target_speed',
  ac_current_speed = 'ac_current_speed',
  ac_current_temperature = 'ac_current_temperature',
  ac_target_temperature = 'ac_target_temperature',
  ac_mode = 'ac_mode',
  on_off = 'on_off',
  aqi = 'aqi',
  color = 'color',
  brightness = 'brightness',
  pressure = 'pressure',
  battery = 'battery',
  voltage = 'voltage',
  ch2o_limit = 'ch2o_limit',
  ch2o_warning_voice = 'ch2o_warning_voice',
  occupancy = 'occupancy',
  software = 'software',
  hardware = 'hardware',
  set_mode = 'set_mode',
  set_on = 'set_on',
  set_off = 'set_off',
  set_value = 'set_value',
  set_ac_mode = 'set_ac_mode',
  set_ac_speed = 'set_ac_speed',
  set_ac_temperature = 'set_ac_temperature',
  set_ink_sync = 'set_ink_sync',
}
export const AppVersionNameEnumObjects: ModelEnumObjects = {
  reservation_pad: {
    position: 0,
  },
  visitor_pad: {
    position: 1,
  },
  locker_pad: {
    position: 2,
  },
}
export const AppVersionNameEnums = [
  'reservation_pad',
  'visitor_pad',
  'locker_pad',
]
export const enum AppVersionNameEnum {
  reservation_pad = 'reservation_pad',
  visitor_pad = 'visitor_pad',
  locker_pad = 'locker_pad',
}
export const LockResourceTypeEnumObjects: ModelEnumObjects = {
  Area: {
    position: 0,
  },
  Resource: {
    position: 1,
  },
  Location: {
    position: 2,
  },
}
export const LockResourceTypeEnums = ['Area', 'Resource', 'Location']
export const enum LockResourceTypeEnum {
  Area = 'Area',
  Resource = 'Resource',
  Location = 'Location',
}
export const LockTypeEnumObjects: ModelEnumObjects = {
  uface: {
    position: 0,
  },
  faceplusplus: {
    position: 1,
  },
  hikvision: {
    position: 2,
  },
  darwin: {
    position: 3,
  },
  bolt: {
    position: 4,
  },
  uface_local: {
    position: 5,
  },
  cabinet: {
    position: 6,
  },
}
export const LockTypeEnums = [
  'uface',
  'faceplusplus',
  'hikvision',
  'darwin',
  'bolt',
  'uface_local',
  'cabinet',
]
export const enum LockTypeEnum {
  uface = 'uface',
  faceplusplus = 'faceplusplus',
  hikvision = 'hikvision',
  darwin = 'darwin',
  bolt = 'bolt',
  uface_local = 'uface_local',
  cabinet = 'cabinet',
}
export const LockEventStatusEnumObjects: ModelEnumObjects = {
  success: {
    position: 0,
  },
  failed: {
    position: 1,
  },
}
export const LockEventStatusEnums = ['success', 'failed']
export const enum LockEventStatusEnum {
  success = 'success',
  failed = 'failed',
}
export const LockEventAccessMethodEnumObjects: ModelEnumObjects = {
  face: {
    position: 0,
  },
  qrcode: {
    position: 1,
  },
}
export const LockEventAccessMethodEnums = ['face', 'qrcode']
export const enum LockEventAccessMethodEnum {
  face = 'face',
  qrcode = 'qrcode',
}
export const LockPermissionSourceTypeEnumObjects: ModelEnumObjects = {
  User: {
    position: 0,
  },
  ResourceReservation: {
    position: 1,
  },
  Visitor: {
    position: 2,
  },
}
export const LockPermissionSourceTypeEnums = [
  'User',
  'ResourceReservation',
  'Visitor',
]
export const enum LockPermissionSourceTypeEnum {
  User = 'User',
  ResourceReservation = 'ResourceReservation',
  Visitor = 'Visitor',
}
export const LockPermissionSyncStatusEnumObjects: ModelEnumObjects = {
  Pending: {
    position: 0,
  },
  Success: {
    position: 1,
  },
  Failed: {
    position: 2,
  },
}
export const LockPermissionSyncStatusEnums = ['Pending', 'Success', 'Failed']
export const enum LockPermissionSyncStatusEnum {
  Pending = 'Pending',
  Success = 'Success',
  Failed = 'Failed',
}
export const FaceAccountTypeEnumObjects: ModelEnumObjects = {
  uface: {
    position: 0,
  },
  faceplusplus: {
    position: 1,
  },
  hikvision: {
    position: 2,
  },
  darwin: {
    position: 3,
  },
  uface_local: {
    position: 4,
  },
}
export const FaceAccountTypeEnums = [
  'uface',
  'faceplusplus',
  'hikvision',
  'darwin',
  'uface_local',
]
export const enum FaceAccountTypeEnum {
  uface = 'uface',
  faceplusplus = 'faceplusplus',
  hikvision = 'hikvision',
  darwin = 'darwin',
  uface_local = 'uface_local',
}
export const AlarmTypeEnumObjects: ModelEnumObjects = {
  offline: {
    position: 0,
  },
  battery: {
    position: 1,
  },
}
export const AlarmTypeEnums = ['offline', 'battery']
export const enum AlarmTypeEnum {
  offline = 'offline',
  battery = 'battery',
}
export const PQLStatusEnumObjects: ModelEnumObjects = {
  HOT: {
    position: 0,
  },
  WARM: {
    position: 1,
  },
  COLD: {
    position: 2,
  },
}
export const PQLStatusEnums = ['HOT', 'WARM', 'COLD']
export const enum PQLStatusEnum {
  HOT = 'HOT',
  WARM = 'WARM',
  COLD = 'COLD',
}
export const CancellationReasonEnumObjects: ModelEnumObjects = {
  too_expensive: {
    position: 0,
  },
  not_enough_features: {
    position: 1,
  },
  switched_to_competitor: {
    position: 2,
  },
  company_closed: {
    position: 3,
  },
  temporary_pause: {
    position: 4,
  },
  not_using_enough: {
    position: 5,
  },
  missing_feature: {
    position: 6,
  },
  technical_issues: {
    position: 7,
  },
  other: {
    position: 8,
  },
}
export const CancellationReasonEnums = [
  'too_expensive',
  'not_enough_features',
  'switched_to_competitor',
  'company_closed',
  'temporary_pause',
  'not_using_enough',
  'missing_feature',
  'technical_issues',
  'other',
]
export const enum CancellationReasonEnum {
  too_expensive = 'too_expensive',
  not_enough_features = 'not_enough_features',
  switched_to_competitor = 'switched_to_competitor',
  company_closed = 'company_closed',
  temporary_pause = 'temporary_pause',
  not_using_enough = 'not_using_enough',
  missing_feature = 'missing_feature',
  technical_issues = 'technical_issues',
  other = 'other',
}
export const PricingChangeTypeEnumObjects: ModelEnumObjects = {
  tier_change: {
    position: 0,
  },
  trial_extension: {
    position: 1,
  },
  coupon_applied: {
    position: 2,
  },
  subscription_paused: {
    position: 3,
  },
  downgrade: {
    position: 4,
  },
  cancellation: {
    position: 5,
  },
}
export const PricingChangeTypeEnums = [
  'tier_change',
  'trial_extension',
  'coupon_applied',
  'subscription_paused',
  'downgrade',
  'cancellation',
]
export const enum PricingChangeTypeEnum {
  tier_change = 'tier_change',
  trial_extension = 'trial_extension',
  coupon_applied = 'coupon_applied',
  subscription_paused = 'subscription_paused',
  downgrade = 'downgrade',
  cancellation = 'cancellation',
}
export const ReferralStatusEnumObjects: ModelEnumObjects = {
  pending: {
    position: 0,
  },
  completed: {
    position: 1,
  },
  expired: {
    position: 2,
  },
}
export const ReferralStatusEnums = ['pending', 'completed', 'expired']
export const enum ReferralStatusEnum {
  pending = 'pending',
  completed = 'completed',
  expired = 'expired',
}
export const ReferralRewardTypeEnumObjects: ModelEnumObjects = {
  month_free: {
    position: 0,
  },
  discount_20: {
    position: 1,
  },
  discount_10: {
    position: 2,
  },
}
export const ReferralRewardTypeEnums = [
  'month_free',
  'discount_20',
  'discount_10',
]
export const enum ReferralRewardTypeEnum {
  month_free = 'month_free',
  discount_20 = 'discount_20',
  discount_10 = 'discount_10',
}
export const DiscountTypeEnumObjects: ModelEnumObjects = {
  percentage: {
    position: 0,
  },
  fixed: {
    position: 1,
  },
}
export const DiscountTypeEnums = ['percentage', 'fixed']
export const enum DiscountTypeEnum {
  percentage = 'percentage',
  fixed = 'fixed',
}
export const QuoteStatusEnumObjects: ModelEnumObjects = {
  draft: {
    position: 0,
  },
  pending_approval: {
    position: 1,
  },
  approved: {
    position: 2,
  },
  sent: {
    position: 3,
  },
  accepted: {
    position: 4,
  },
  expired: {
    position: 5,
  },
  rejected: {
    position: 6,
  },
}
export const QuoteStatusEnums = [
  'draft',
  'pending_approval',
  'approved',
  'sent',
  'accepted',
  'expired',
  'rejected',
]
export const enum QuoteStatusEnum {
  draft = 'draft',
  pending_approval = 'pending_approval',
  approved = 'approved',
  sent = 'sent',
  accepted = 'accepted',
  expired = 'expired',
  rejected = 'rejected',
}
export const ExperimentTypeEnumObjects: ModelEnumObjects = {
  pricing: {
    position: 0,
  },
  feature: {
    position: 1,
  },
  ui: {
    position: 2,
  },
  email: {
    position: 3,
  },
  onboarding: {
    position: 4,
  },
}
export const ExperimentTypeEnums = [
  'pricing',
  'feature',
  'ui',
  'email',
  'onboarding',
]
export const enum ExperimentTypeEnum {
  pricing = 'pricing',
  feature = 'feature',
  ui = 'ui',
  email = 'email',
  onboarding = 'onboarding',
}
export const ABTestStatusEnumObjects: ModelEnumObjects = {
  draft: {
    position: 0,
  },
  running: {
    position: 1,
  },
  paused: {
    position: 2,
  },
  completed: {
    position: 3,
  },
}
export const ABTestStatusEnums = ['draft', 'running', 'paused', 'completed']
export const enum ABTestStatusEnum {
  draft = 'draft',
  running = 'running',
  paused = 'paused',
  completed = 'completed',
}
export const ABTestWinnerEnumObjects: ModelEnumObjects = {
  control: {
    position: 0,
  },
  treatment: {
    position: 1,
  },
  inconclusive: {
    position: 2,
  },
}
export const ABTestWinnerEnums = ['control', 'treatment', 'inconclusive']
export const enum ABTestWinnerEnum {
  control = 'control',
  treatment = 'treatment',
  inconclusive = 'inconclusive',
}
export const ABTestVariantEnumObjects: ModelEnumObjects = {
  control: {
    position: 0,
  },
  treatment: {
    position: 1,
  },
}
export const ABTestVariantEnums = ['control', 'treatment']
export const enum ABTestVariantEnum {
  control = 'control',
  treatment = 'treatment',
}
export const CampaignTypeEnumObjects: ModelEnumObjects = {
  first_month_free: {
    position: 0,
  },
  percentage_off: {
    position: 1,
  },
  extended_trial: {
    position: 2,
  },
  flat_discount: {
    position: 3,
  },
}
export const CampaignTypeEnums = [
  'first_month_free',
  'percentage_off',
  'extended_trial',
  'flat_discount',
]
export const enum CampaignTypeEnum {
  first_month_free = 'first_month_free',
  percentage_off = 'percentage_off',
  extended_trial = 'extended_trial',
  flat_discount = 'flat_discount',
}
export const TargetAudienceEnumObjects: ModelEnumObjects = {
  new: {
    position: 0,
  },
  returning: {
    position: 1,
  },
  churned: {
    position: 2,
  },
  all: {
    position: 3,
  },
}
export const TargetAudienceEnums = ['new', 'returning', 'churned', 'all']
export const enum TargetAudienceEnum {
  new = 'new',
  returning = 'returning',
  churned = 'churned',
  all = 'all',
}
export const CampaignStatusEnumObjects: ModelEnumObjects = {
  draft: {
    position: 0,
  },
  active: {
    position: 1,
  },
  paused: {
    position: 2,
  },
  ended: {
    position: 3,
  },
}
export const CampaignStatusEnums = ['draft', 'active', 'paused', 'ended']
export const enum CampaignStatusEnum {
  draft = 'draft',
  active = 'active',
  paused = 'paused',
  ended = 'ended',
}
export const CaseStudyRequestStatusEnumObjects: ModelEnumObjects = {
  pending: {
    position: 0,
  },
  contacted: {
    position: 1,
  },
  scheduled: {
    position: 2,
  },
  completed: {
    position: 3,
  },
  declined: {
    position: 4,
  },
}
export const CaseStudyRequestStatusEnums = [
  'pending',
  'contacted',
  'scheduled',
  'completed',
  'declined',
]
export const enum CaseStudyRequestStatusEnum {
  pending = 'pending',
  contacted = 'contacted',
  scheduled = 'scheduled',
  completed = 'completed',
  declined = 'declined',
}
export const TrialFeatureEnumObjects: ModelEnumObjects = {
  sso: {
    position: 0,
  },
  calendarSync: {
    position: 1,
  },
  teamsIntegration: {
    position: 2,
  },
  customRoles: {
    position: 3,
  },
  advancedAnalytics: {
    position: 4,
  },
  advancedRules: {
    position: 5,
  },
  scim: {
    position: 6,
  },
  multiLocation: {
    position: 7,
  },
  hardware: {
    position: 8,
  },
  apiAccess: {
    position: 9,
  },
  customBranding: {
    position: 10,
  },
  sla: {
    position: 11,
  },
  visitorManagement: {
    position: 12,
  },
}
export const TrialFeatureEnums = [
  'sso',
  'calendarSync',
  'teamsIntegration',
  'customRoles',
  'advancedAnalytics',
  'advancedRules',
  'scim',
  'multiLocation',
  'hardware',
  'apiAccess',
  'customBranding',
  'sla',
  'visitorManagement',
]
export const enum TrialFeatureEnum {
  sso = 'sso',
  calendarSync = 'calendarSync',
  teamsIntegration = 'teamsIntegration',
  customRoles = 'customRoles',
  advancedAnalytics = 'advancedAnalytics',
  advancedRules = 'advancedRules',
  scim = 'scim',
  multiLocation = 'multiLocation',
  hardware = 'hardware',
  apiAccess = 'apiAccess',
  customBranding = 'customBranding',
  sla = 'sla',
  visitorManagement = 'visitorManagement',
}

export const enum MapResourceMarkerDisplayEnum {
  Icon = 'Icon',
  ResourceName = 'ResourceName',
}
